import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { HDRJPGLoader } from '@monogrid/gainmap-js'
var loaderMain;
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactSlider from 'react-slider';

import {
    faGrid5,
    faPlus,
    faCheck,
    faCamera,
    faGears,
    faPenToSquare,
    faEllipsis,
    faDownload,
    faHandMiddleFinger,
    faHand,
    faUpload, faComment,
    faLock, faCircleInfo,
} from '@fortawesome/pro-regular-svg-icons';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

import io from 'socket.io-client';
import ReactTooltip from 'react-tooltip';
import styled from 'styled-components';
import Comment from '../pages/editor/Comment';
import { useRouter } from 'next/router';
import { EditorData } from '../global/testingData';
import { AppConfig } from '../../../app_config';
import * as Sentry from '@sentry/nextjs';
import { borderRadius22 } from '../global/Variables.js';

import {
    EditorLeftActionsBarWrapper,
    EditorLeftActionsBarMinimal,
    EditorLeftActionsBarWindow,
    EditorRightActionsBar,
    EditorRightActionsBarWindow,
    EditorSetFrontFaceRotationLine,
    EditorSetFrontFaceRotationBottom,
    EditorSetFrontFaceRotationTop,
    EditorSetFrontFaceRotationLeft,
} from '../pages/editor/styles/EditorStyles';

import {
    ModalWindow,
    ModalsWrapper,
    LoginButton,
    GlobalButtonFinal,
    GlobalButtonFinalSmall
} from '../global/GlobalStyles';
import { signOut, useSession } from 'next-auth/client';
import * as THREEController from '../pages/editor/THREEController';
import { FormattedMessage } from 'react-intl';
import messages from '../../../src/messages';
import { deleteCookie, getCookie, setCookie } from 'cookies-next';
import DialogAlert from '../global/dialogs/DialogAlert';
import Head from 'next/head';
import DialogEditor from '../global/dialogs/DialogEditor';
import DialogChooseProductShrink from '../global/dialogs/DialogChooseProductShrink';
import PackshotDetailModal from '../global/packshots/PackshotDetailModal';
import { LangContext } from '../../../src/ConnectedIntlProvider';

import DialogDeleteComment from '../global/dialogs/DialogDeleteComment';
import NewProduct from '../pages/newproduct/NewProduct';
import DialogBuyCredits from '../global/dialogs/DialogBuyCredits';
import DialogLeaveTeam from '../global/dialogs/DialogLeaveTeam';
import DialogConfirmRender from '../global/dialogs/DialogConfirmRender';

import { fpsLowered } from '../pages/editor/THREEController';
import Link from 'next/link';
import { log } from '../../logger';
import { useAppContext } from '../../../context/AuthContext';



export const StyledCommentsHeader = styled.div`

    position: fixed;
    background: white;
    z-index: 9;
    width: 87%;
    top: 6px;
    padding-top: 10px;
    
    
    .comments{
        margin-top:15px;


       
    }
    
    .comments-header{
        margin-top:15px;
        padding-bottom:15px;
        border-bottom:1px solid lightgray;
    }
    .addNew{

        border-radius: 18px;
        border: 1px solid var(--Buton-Active-Dark, #3D55D7);

        min-width:unset !important;
        width: 36px;
        height: 36px;
        padding: var(--Subscription-Nr-of-Users, 5px) 36px;
    right:unset !important;
        left:0;
        float:left;
        display:inline-block;
        justify-content: center;
        align-items: center;
        padding:0;
        gap: 10px;
        color: var(--Buton-Active, var(--Buton-Active-Dark, #3D55D7));
        text-align: center;
        /* Buton/Icon Regular */
        font-family: "Font Awesome 6 Pro";
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        
        svg{
            color:#3D55D7;
        }
        
        &:hover{
          background:#3D55D7;
            svg{
                color:white;
            }
        }
    }

    .nav-tabs{
        position: relative;
        display: inline-block;
        width: 196px;
        
        text-align: center;

    
        margin: auto auto;
        
        background: rgba(0,0,0,0.15);
        padding: 4px !important;

        border-radius: ${borderRadius22};

        padding-bottom: 5px  !important;
margin-top:3px !important;
     

        li {
            text-transform: none;
            margin-top:0 !important;
            padding: 0 !important;

        }
        
        .nav-link{
            color: var(--black-100, #000);
            text-align: center;
            /* Buton/Text Small */
            font-family: "Nunito Sans";
            font-size: 14px;
            font-style: normal;
            font-weight: 300;
            line-height: normal;
            border:none !important;
            a{
                color: var(--black-100, #000);
                text-align: center;
                /* Buton/Text Small */
                font-family: "Nunito Sans";
                font-size: 14px;
                font-style: normal;
                font-weight: 300;
                line-height: normal;

            }
            //    @media screen and (max-height: 800px) {
            //        font-size:14px !important;
            // }
            &.active,
            &:hover{
                border:none !important;
                background:white  !important;
            }
        }
    }
`;


export const StyledComments = styled.div`
    
    .comments{
        margin-top:15px;
    }
    span, label, p {
        font-size: 14px;
    }
    
   
`;
export const RotationCanvas = styled.div`
    display: none;

    width: 75%;
    height: 76%;
    z-index: 99999999;
    position: absolute;

    left: 50%;
    transform: translateX(-50%);

    &.show {
        display: block;
    }
`;

export const CommentCanvas = styled.div`
    display: none;

    width: 75%;
    height: 76%;
    z-index: 99999999;
    position: absolute;

    left: 50%;
    transform: translateX(-50%);

    &.show {
        display: block;
    }
`;

export const LoaderUI = styled.div`
    z-index: 9999999;
    background: rgba(255, 255, 255, 1);
    position: absolute;
    left: 0;
    top: 5px;

    width: 100%;
    height: 99%;

    border-radius: ${borderRadius22};
    img {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 40px;
    }

    transition: all 0.5s ease;

    opacity: 0;

    &.showTransition {
        opacity: 0.9;
    }
    &.hideTransition {
        opacity: 0;
    }
    display: block;
    &.hiddeComplete {
        display: none;
    }
`;

export const LoaderEditor = styled.div`
    transition: all 0.5s ease;
    .innerLoading {
        width: 2070px;
        height: 150px;
        left: 50%;
        position: absolute;
        top: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        p {
            margin-top: 15px;
        }
    }
    .CircularProgressbar {
        width: 93px;
        height: 93px;
    }
    .CircularProgressbar .CircularProgressbar-path {
       // stroke: #3d3d3d;
        stroke: #666;
    }
    .CircularProgressbar .CircularProgressbar-text {
      //  fill: #3d3d3d;
        fill: #666;
        font-size: 13px;
    }
    &.showTransition {
        opacity: 1 !important;
    }

    &.hideTransition {
        opacity: 0;
        display:block;
    }

    display: block;

    &.hiddeComplete {
        display: none;
    }
`;
 let socket;
let socketEditor;
let socketComments;

export default function ProductEditor({
    props: any,
    plugin,
    setUserRole,
    toggle,
    toggleReinitRenderer,
                                          setCanBeRendered,
    setProductNameMaster,
    setProductVersionNameMaster,
    setBreadcrumbs,
    triggerShowRender,
    hitTriggerShowRender,
    setUpMenuProductIDZ,
    toggleWindowResize,
    pluginProductID,
    setVersionIsLocked,
    versionIsLocked,
}) {
    const router = useRouter();
    const { slug } = router.query;
    const [session, loading] = useSession();
    if (!plugin) {
        if (typeof window !== 'undefined' && loading) return null;

        if (!loading && !session) {
            const router = useRouter();
            router.push('/');
            return null;
        }
    }
    const toggleHelloWorld = useCallback((): void => {}, []);
    useEffect(() => {
        if (triggerShowRender) {
            changeRenderShow(true);
        } else {
            changeRenderShow(false);
        }
    }, [triggerShowRender]);
    useEffect(() => {
        toggle && toggle(toggleHelloWorld);
    }, [toggle, toggleHelloWorld]);

    const { language, setLanguage } = useContext(LangContext);

    const [rotationCanvasShow, setRotationCanvasShow] = useState(false);

    const [loadingProgressPercent, setLoadingProgressPercent] = useState(0);

    const [loadingProgressSentence, setLoadingProgressSentence] = useState('prepairing');

    const [loadProductsShow, setLoadProductsShowVariable] = useState(true);
    const [loadTransitionProductsShow, setLoadTransitionProductsShow] = useState(true);
    const [typeLoading, setTypeLoading] = useState("initMane");



    const [allEditorMenuActions, setAllMenuLevelsActions] = useState([]);
    const [currentScene, setCurrentScene] = useState([]);

    const [drawingLinks, setDrawingLinks] = useState([]);
    const [openingY, setOpeningY] = useState(0);
    const [actionMenu, setActionMenu] = useState('full');
    const [actionsOptionsOpenedName, setActionsOpenedName] = useState('full');
    const [fullScreened, changeFullScreened] = useState(false);
    const [sharedUsers, setSharedUsers] = useState([]);
    const [editorScenes, setEditorScenes] = useState([]);
    const [backgroundColors, setBackgroundColors] = useState([]);
    const [bodyModel, setBodyModel] = useState(null);
    const [openingModel, setOpeningModel] = useState(null);
    const [openingModelName, setOpeningModelName] = useState(null);
    const [openingModelUUID, setOpeningModelUUID] = useState(null);

    const [productName, setProductName] = useState('');
    const [productVersionName, setProductVersionName] = useState('');
    const [helpActive, setHelpActive] = useState(true);
    // const [packshotRenderWindow, setPackshotRenderWindowActive] = useState(false);


    const [commentActive, setCommentActive] = useState(false);
    const commentActiveRef = useRef(commentActive);
// Aktualizace ref při změně stavu
    useEffect(() => {
        commentActiveRef.current = commentActive;
    }, [commentActive]);

    const [cubeActive, setCubeActive] = useState(false);
    const [actionsActive, setActionsActive] = useState(true);
    const [backgroundEditor, setBackgroundEditor] = useState('lightgray');
    const [loadProductsShowUI, setLoadProductsShowVariableUI] = useState(false);
    const [loadTransitionProductsShowUI, setLoadTransitionProductsShowUI] = useState(false);
    const [eyeActive, setEyeActive] = useState(false);
    const [gridActive, setGridActive] = useState(false);
    const [rulerActive, setRulerActive] = useState(false);
    const [renderActive, setRenderActive] = useState(false);
    const [rulerButtonChecked, setRulerButtonChecked] = useState(false);
    const [gridButtonChecked, setGridButtonChecked] = useState(true);
    const [developerButtonChecked, setDeveloperButtonChecked] = useState(false);
    const [masterProductUUID, setMasterProductUUID] = useState(null);
    const [versionProductUUID, setVersionProductUUID] = useState(null);
    const [userSelectedOptionsVar, setUserSelectedOptionsVar] = useState([]);
    const [editorMode, changeEditorMode] = useState('edit');
    const [editorUserMode, changeEditorUserMode] = useState('edit');
    const [userTeamState, setUserTeamState] = useState(null);
    const [userTokenState, setUserTokenState] = useState(null);
    const [slugState, setSlugState] = useState(null);
    const [originalSlugState, setOriginalSlugState] = useState(null);

    const [renderModelOpening, setRenderModelOpening] = useState('');
    const [renderModelBody, setRenderModelBody] = useState('');
    const [mainTextureBody, setMainTextureBody] = useState('');
    const [alphaTextureBody, setAlphaTextureBody] = useState('');


    const [openingID, setOpeningID] = useState('');

    const [openingColorState, setOpeningColor] = useState('');

    const openingColorRef = useRef(""); // Nebo useRef(null);

       const openingColorsRef = useRef("");
    const openingColorUUIDRef = useRef("");



    const [productSize, setProductSize] = useState(false);
    const [productPackage, setProductPackage] = useState(false);
    const [uploadedTexture, setUploadedTexture] = useState(null);
    const [uploadedTextureType, setUploadedTextureType] = useState(null);


    const [estimatedTimeRenderLow, setEstimatedTimeRenderLow] = useState('5');
    const [estimatedTimeRenderMid, setEstimatedTimeRenderMid] = useState('10');
    const [estimatedTimeRenderHigh, setEstimatedTimeRenderHigh] = useState('15');



    const [showRenderModal, setShowRenderModal] = useState(false);
    const [showRenderModalTransition, setShowRenderModalTransition] = useState(false);
    const [currentPackageUUID, setCurrentPackageUUID] = useState(null);

    const [showEditorPackageOpeningsModal, setShowEditorPackageOpeningsModal] = useState(false);

    const [showEditorPackageOpeningsModalTransition, setShowEditorPackageOpeningsModalTransition] = useState(false);

    const [showEditorColorsModal, setShowEditorColorsModal] = useState(false);

    const [mainDesignValues, setMainDesignValues] = useState([]);

    const [alphaDesignValues, setAlphaDesignValues] = useState([]);
    const [metallicDesignValues, setMetallicDesignValues] = useState([]);


    const [threeInited, setThreeInited] = useState(false);

    const [showEditorColorsModalTransition, setShowEditorColorsModalTransition] = useState(false);

    const [qualityRender, setQualityRender] = useState(null);

    const [creditAmount, setCreditAmount] = useState(0);
    const [renderTime, setRenderTime] = useState(0);


    const [fpsLoweredState, setFPSLowered] = useState(false);
    const { authData, refreshAuthInfo, setLanguageFunction, loadTeamInfoAPI, allLanguages } = useAppContext();

    function capitalize(s) {
        return s[0].toUpperCase() + s.slice(1);
    }
    const fullScreen = (e, key, uuid) => {
        if (!fullScreened) {
            if (document.body.requestFullscreen) {
                document.body.requestFullscreen();
            } else if (document.body.webkitRequestFullscreen) {
                /* Safari */
                document.body.webkitRequestFullscreen();
            } else if (document.body.msRequestFullscreen) {
                /* IE11 */
                document.body.msRequestFullscreen();
            }
            changeFullScreened(true);
        } else {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.webkitExitFullscreen) {
                /* Safari */
                document.webkitExitFullscreen();
            } else if (document.msExitFullscreen) {
                /* IE11 */
                document.msExitFullscreen();
            }
            changeFullScreened(false);
        }
    };

    const uploadFBX = e => {
        THREEController.loadModelFromInput(e[0], function (scene) {

        });
    };

    // var socket;

    var [productRotating, setProductRotating] = useState(false);

    const rotateProduct = () => {
        if (!productRotating) {
            setProductRotating(true);
        } else {
            setProductRotating(false);
        }
        THREEController.rotateProduct();
    };


    var [valueRotationX, setValueRotationX] = useState(0);



    const setLoadProductsShow = variable => {
        if (variable === true) {
            setLoadProductsShowVariable(variable);
            setLoadTransitionProductsShow(true);
        } else {
            setTimeout(function () {
                setLoadTransitionProductsShow(false);
                setTimeout(function () {
                    setLoadProductsShowVariable(variable);
                }, 500);
            }, 300);
        }
    };


    const setBackgroundColor = (backgroundColor, gridColor, gridOpacity) => {
        setBackgroundEditor(backgroundColor);

        THREEController.changeBackgroundColor(backgroundColor, gridColor, gridOpacity, gridButtonChecked);
    };

    const setBackgroundColorGradient = (gradientHDRUrl, gridColor, gridOpacity) => {
        THREEController.changeBackgroundColorGradient(gradientHDRUrl, gridColor, gridOpacity, gridButtonChecked);

        setBackgroundEditor(gradientHDRUrl);
    };

    const changeRenderShow = variable => {
        if (variable === true) {
            setPackshotDetailUUID(false);
            setShowRenderModal(true);
            loadRenderViews();
            setTimeout(function () {
                setShowRenderModalTransition(variable);
            }, 2);
        } else {

            setShowRenderModalTransition(false);
            setTimeout(function () {
                setPackshotDetailUUID(false);
                setShowRenderModal(variable);
            }, 500);
        }
    };

    const changeEditorPackageOpeningsShow = (variable, type) => {
        if (variable === true) {

            setShowEditorPackageOpeningsModal(true);
            setTimeout(function () {
                setShowEditorPackageOpeningsModalTransition(variable);
            }, 2);
        } else {
            setShowEditorPackageOpeningsModalTransition(false);
            setTimeout(function () {
                setShowEditorPackageOpeningsModal(variable);
            }, 500);
        }
    };

    const changeEditorColorsShow = (variable, type) => {
        if (variable === true) {
            setActiveColorChoose(type);

            setShowEditorColorsModal(true);
            setTimeout(function () {
                setShowEditorColorsModalTransition(variable);
            }, 2);
        } else {
            setShowEditorColorsModalTransition(false);
            setTimeout(function () {
                setShowEditorColorsModal(variable);
            }, 500);
        }
    };

    var [newComment, setNewComment] = useState(false);
    var [newCommentPosition, setNewCommentPosition] = useState(null);
    const callBackComments = (position) => {
        setNewCommentPosition(position);
        setNewComment(true);
        handleClickNewComment();
        THREEController.setCommentMode(false);
        setCommentActive(true);
        setCommentCanvasShow(false);

    };


    const getCommentColorByStatus = (status) => {

        var color= 0xffffff;

        if(status === "open" ||status === "new" ){
            color = 0xFFC700;
        }
        if(status === "resolved"){
            color = 0x23c703;
        }
        if(status === "rejected"){
            color = 0xc70303;
        }

        if(status === "cancelled"){
            color = 0x9747FF;
        }

        return color;
    };



    const closeComments = (state) => {

        if(editorUserMode !== "comment" || editorUserMode !== "view" ){
            changeEditorMode("edit");
        }


        THREEController.removeDecals();
        THREEController.disablecomments();
        setCommentActive(false);


    };
    const activateCommentsNew = (state) => {

        THREEController.setCommentMode(state, callBackComments, allComments.length);

      //  setCommentActive(state);

        if (state) {


            setCommentCanvasShow(true);
        } else {
            setCommentCanvasShow(false);
        }



    };


    const changeCurrentScene = replaceUUID => {
        editorScenes.map((editorScene, indexEditorScene) => {
            if (replaceUUID == editorScene.uuid) {
                THREEController.loadEnviroment(editorScene.value);
            }
        });
        setCurrentScene(replaceUUID);
    };

    const changeActionMenu = value => {

        if (value !== 'default' && actionMenu !== value) {
            setActionsActive(true);
            setActionMenu(value);
            setActionsOpenedName(value);
        } else {
            setActionsActive(false);
            setActionMenu('default');
        }
    };

    const changeGridButton = gridButtonValue => {
        setGridButtonChecked(gridButtonValue);

        if (gridButtonValue) {
            THREEController.ToggleGrid(true);
        } else {
            THREEController.ToggleGrid(false);
        }
    };


    const changeDeveloperButton = developerButtonValue => {
        setDeveloperButtonChecked(developerButtonValue);

        if (developerButtonValue) {
            THREEController.ToggleDeveloperGUI(true);
        } else {
            THREEController.ToggleDeveloperGUI(false);
        }
    };
    const changeRulerButton = rulerButtonValue => {
        setRulerButtonChecked(rulerButtonValue);

        if (rulerButtonValue) {
            THREEController.ToggleRulers(true);
        } else {
            THREEController.ToggleRulers(false);
        }
    };

    var [newCommentCount, setCurrentNewCommentCount] = useState(0);

    const openWindowPopup = popupWindow => {
        var isCubeOpened = cubeActive;
        var isEyeOpened = eyeActive;

        setHelpActive(false);
        setCubeActive(false);
        setEyeActive(false);
        setGridActive(false);
        setRulerActive(false);
        setRenderActive(false);

        if (popupWindow === 'help') {
        }
        if (popupWindow === 'comment') {
            setCommentActive(true);
            changeEditorMode("comment");

            allComments.map(comment => {
                THREEController.makeCommentOnPack(comment.position,setCurrentNewCommentCount, comment.number, getCommentColorByStatus(comment.status.status) );
            });

        }
        if (popupWindow === 'cube' && !isCubeOpened) {
            setCubeActive(true);
        }
        if (popupWindow === 'eye' && !isEyeOpened) {
            setEyeActive(true);
        }
        if (popupWindow === 'grid') {
            setGridActive(true);
        }
        if (popupWindow === 'ruler') {
            setRulerActive(true);
        }
        if (popupWindow === 'render') {
            setRenderActive(true);
        }
    };


    ///////////////////////// RENDERING
    async function postDataAPI(quality, sceneUUID, sceneVersionUUID, droplets, transparentBG) {
        const response = await fetch(process.env.NEXT_PUBLIC_OBALERO_API_BASEPATH + 'renders', {
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
                Authorization: 'Bearer ' + userTeamState, // notice the Bearer before your token
            },
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: JSON.stringify({
                product_version: slugState.toString(),
                quality: quality.toString(),
                // type: renderType.toString(),
                scene: sceneUUID,
                scene_version: sceneVersionUUID,
                render_scene_view: packshotDetailUUID
                // options: {
                //     droplets: droplets,
                //     transparent_background: transparentBG,
                // },
            }), // body data type must match "Content-Type" header
        });
        return response.json(); // parses JSON response into native JavaScript objects
    }




    let handleCLickConfirmRender = () => {

    };
    let handleCLickConfirmRenderClose = () => {

    };




    var [currentCreditsAlocate, setCurrentCreditsAlocate] = useState(0);


    var [lowQualityRendering, setLowQualityRendering] = useState(false);
    var [mediumQualityRendering, setMediumQualityRendering] = useState(false);
    var [highQualityRendering, setHighQualityRendering] = useState(false);




    const renderPackshot = (quality) => {


        handleCLickConfirmRenderClose();

        if(authData.teamCredits > 0){


            if(quality === "low"){
                if(authData.teamCredits >= renderScenes[0].pricing.low){
                   // setCurrentCreditsAlocate( currentCreditsAlocate + renderScenes[0].pricing.low);
               //     setTeamCreditsInner(teamCreditsInner -  renderScenes[0].pricing.low);
                    setLowQualityRendering(true);

                } else {

                    triggerWarning(language === "cs" ? 'Nedostatek kreditů' : 'Not enough credits');
                    return;
                  //  setCurrentCreditsAlocate( 0);
                }


            }

            if(quality === "medium"){
                if(authData.teamCredits >= renderScenes[0].pricing.medium){
                   // setCurrentCreditsAlocate( currentCreditsAlocate + renderScenes[0].pricing.medium);
              //      setTeamCreditsInner(teamCreditsInner -  renderScenes[0].pricing.medium);
                    setMediumQualityRendering(true);
                } else {

                    triggerWarning(language === "cs" ? 'Nedostatek kreditů' : 'Not enough credits');
                    return;
                    setCurrentCreditsAlocate( 0);
                }


            }
            if(quality === "high"){
                if(authData.teamCredits >= renderScenes[0].pricing.high){
                 //   setCurrentCreditsAlocate( currentCreditsAlocate + renderScenes[0].pricing.high);
              //      setTeamCreditsInner(teamCreditsInner -  renderScenes[0].pricing.high);
                    setHighQualityRendering(true);
                } else {

                    triggerWarning(language === "cs" ? 'Nedostatek kreditů' : 'Not enough credits');
                    return;

                  //  setCurrentCreditsAlocate( 0);
                }

            }


                postDataAPI(quality, renderScenes[0].uuid, renderScenes[0].versions[renderScenes[0].versions.length-1].uuid, false, false).then(data => {


                    if (data.error_code && (data.error_code === 'API_NOT_ENOUGH_CREDITS' || data.error_code === 'NOT_ENOUGH_CREDITS')) {

                        triggerWarning(language === "cs" ? 'Nedostatek kreditů' : 'Not enough credits');
                        if(quality === "low"){
                       //     setCurrentCreditsAlocate( currentCreditsAlocate -  renderScenes[0].pricing.low);
                        }

                        if(quality === "medium"){
                         //   setCurrentCreditsAlocate( currentCreditsAlocate -  renderScenes[0].pricing.medium);
                        }
                        if(quality === "high"){
                        //    setCurrentCreditsAlocate( currentCreditsAlocate -  renderScenes[0].pricing.high);
                        }

                        setLowQualityRendering(false);
                        setMediumQualityRendering(false);
              //          setTeamCreditsInner(teamCreditsInner);
                        setHighQualityRendering(false);

                    }
                    if (data.success === true) {
                        refreshAuthInfo();



                    }
                });

        } else{

            triggerWarning(language === "cs" ? 'Nedostatek kreditů' : 'Not enough credits');

            setLowQualityRendering(false);
            setMediumQualityRendering(false);
            setHighQualityRendering(false);
        }
    };

    var [lowPackshotDate, setLowPackshotDate] = useState(null);
    var [mediumPackshotDate, setMediumPackshotDate] = useState(null);
    var [highPackshotDate, setHighPackshotDate] = useState(null);

    var [lowPackshotUrl, setLowPackshotUrl] = useState(null);
    var [mediumPackshotUrl, setMediumPackshotUrl] = useState(null);
    var [highPackshotUrl, setHighPackshotUrl] = useState(null);


    ///////////////////////////////////////////////////
    const openRenderPackshot = (quality, creditAmount, renderTime) => {
        handleCLickConfirmRender();
        setQualityRender(quality);

        setCreditAmount(creditAmount);
        setRenderTime(renderTime);


    };
    ///////////////////////////////////////////////////

    const changeOpening = openingUUID => {
        fetch(process.env.NEXT_PUBLIC_OBALERO_API_BASEPATH + 'products/' + masterProductUUID + '/versions/' + versionProductUUID, {
            method: 'PUT',
            body: JSON.stringify({
                package_opening: openingUUID,
            }),
            headers: {
                'Content-type': 'application/json',
                Authorization: 'Bearer ' + userTeamState, // notice the Bearer before your token
            },
        })
            .then(response => response.json())
            .then(function (data) {
                if (data.message !== undefined) {
                    Sentry.captureException('products/' + masterProductUUID + '/versions/' + versionProductUUID + ': ' + data.message + ' : ' + getCookie('userMail'));
                }

                if (data.message === undefined) {
                    changeEditorPackageOpeningsShow(false, 'tabs');

                    setPackageOpeningUUID(openingUUID);
                    packageOpenings.map(openingItem => {
                        if (openingItem.uuid === openingUUID) {
                            console.log("nastavuju opening", openingItem, openingColors);

                            var newColor = getOptionValueFromUUID(openingColorUUID);
                            if (!openingColorState) {
                                console.log("Barva víčka (openingColor) není nastavena. Pokouším se najít výchozí podle thumbnailu.");

                                // 2. Najdi první položku v openingColors, která odpovídá hodnotě v thumbnailu
                                const defaultColorItem = openingColors.find(item =>
                                    item.value === openingItem.thumbnail.options["opening-color"]
                                );

                                // 3. Pokud byla nalezena odpovídající výchozí barva
                                if (defaultColorItem) {
                                    console.log(`Nalezena výchozí barva: ${defaultColorItem.name}, Hodnota: ${defaultColorItem.value}`);

                                    // Použij nalezenou hodnotu pro nastavení stavu
                                    const vysledek = oddelitBarvuAAlfu(defaultColorItem.value); // Použijeme hodnotu z nalezené položky

                                    setOpeningColor(vysledek.barva);
                                    openingColorRef.current =vysledek.barva;
                                    setOpeningColorName(getOptionNameFromUUID(defaultColorItem.uuid));
                                    setOpeningColorUUID(defaultColorItem.uuid);


                                    openingColorUUIDRef.current = defaultColorItem.uuid;

                                    newColor = openingItem.thumbnail.options["opening-color"];

                                } else {
                                    console.log("Pro hodnotu z thumbnailu nebyla nalezena odpovídající výchozí barva:", openingItem.thumbnail.options["opening-color"]);
                                    // Zde můžeš případně nastavit nějakou úplně základní výchozí barvu, pokud nebyla nalezena shoda
                                    // např. setOpeningColor("#FFFFFF"); setOpeningColorName("Bílá"); setOpeningColorUUID(null);
                                }

                            } else {
                                // 4. Pokud už openingColor nastavená JE, nic nedělej a jen to zaloguj
                                console.log("Barva víčka (openingColor) je již nastavena na:", openingColorState, ". Přeskakuji přepis výchozí barvou.");
                            }
                          /*  openingColors.forEach((item, index) => {
                                // Porovnání hodnot 'value' a 'color'
                                if (item.value ===  openingItem.thumbnail.options["opening-color"]) {
                                    const vysledek = oddelitBarvuAAlfu(openingItem.thumbnail.options["opening-color"]);

                                    setOpeningColor(vysledek.barva);
                                    setOpeningColorName(getOptionNameFromUUID(item.uuid));

                                    setOpeningColorUUID(item.uuid);
                                    // Pokud se shodují, vypíše se zpráva do konzole
                                    console.log(`Nalezena shoda u položky ${index + 1} (${item.name}): value '${item.value}' === color '${item.color}'`);
                                } else {
                                    // Volitelně: Můžeš logovat i případy, kde shoda není
                                    // console.log(`Neshoda u položky ${index + 1} (${item.name}): value '${item.value}' !== color '${item.color}'`);
                                }
                            });
*/
                            setPackageOpeningName(openingItem.name);
                          //  console.log("nastaveujeme vsibilitu",  openingItem.thumbnail.options["opening-color"]);
                            THREEController.changeOpeningModelVisibility(openingItem.description, packageOpenings, newColor);
                        }
                    });
                }

            });
    };



    var [activeComment, setActiveComment] = useState(null);
    var [allComments, setAllComments] = useState([]);
    var [allCommentsOriginal, setAllCommentsOriginal] = useState([]);

    var [commentsFilterType, setCommentsFilterType] = useState("all");
    const addTempComment = (commentNewAdd) => {

        if(commentsFilterType === 'all'){
            var newArray = allCommentsOriginal;
            newArray.push(commentNewAdd);

            setAllComments(allCommentsOriginal);
            setCommentsFilterType("all");

            THREEController.removeDecals();
            allCommentsOriginal.map(comment => {

                THREEController.makeCommentOnPack(comment.position,setCurrentNewCommentCount,comment.number, getCommentColorByStatus(comment.status.status) );
            });



        } else {

            var newArray=[];
            setCommentsFilterType("unresolved");
            allCommentsOriginal.map(comment => {

                if(comment.status.status === "open" || comment.status.status === "new"){
                    newArray.push(comment);
                }
            });

            setAllComments(newArray);
            THREEController.removeDecals();
            newArray.map(comment => {

                THREEController.makeCommentOnPack(comment.position,setCurrentNewCommentCount,comment.number, getCommentColorByStatus(comment.status.status) );
            });


        }
    }
    const filterComments = (typeFilter) => {

            if(typeFilter === 'all'){
                setAllComments(allCommentsOriginal);
                setCommentsFilterType("all");

                    THREEController.removeDecals();
                    allCommentsOriginal.map(comment => {

                        THREEController.makeCommentOnPack(comment.position,setCurrentNewCommentCount,comment.number, getCommentColorByStatus(comment.status.status) );
                    });

                if(activeComment && activeComment!== undefined){

                    setActiveCommentFc(activeComment);
                }





            } else {

                var newArray=[];

                setCommentsFilterType("unresolved");
                allCommentsOriginal.map(comment => {

                    if(comment.status.status === "open" || comment.status.status === "new"){
                        newArray.push(comment);
                    }
                });

                setAllComments(newArray);

                THREEController.removeDecals();
                newArray.map(comment => {

                    THREEController.makeCommentOnPack(comment.position,setCurrentNewCommentCount,comment.number, getCommentColorByStatus(comment.status.status) );
                });

                if(activeComment && activeComment!== undefined){

                    setActiveCommentFc(activeComment);
                }


            }
    }

    const setActiveCommentFc = (numberComment) => {
        if(newComment){
            THREEController.removeCommentPack(allComments-1);
        }
        THREEController.setActiveComment(numberComment);
        setActiveComment(numberComment);
        setNewComment(false);
    }
    const loadComments = (versionUUID,reloaded, socket, newNumber) => {
        if(socket){
            if(commentActiveRef.current){
                fetch(process.env.NEXT_PUBLIC_OBALERO_API_BASEPATH + 'corrections/version/' + versionUUID, {
                    method: 'GET',
                    headers: {
                        'Content-type': 'application/json',
                        Authorization: 'Bearer ' + userTeamState, // notice the Bearer before your token
                    },
                })
                    .then(response => response.json())
                    .then(function (data) {
                        if (data.message !== undefined) {
                            Sentry.captureException('corrections/version/' +versionUUID + ': ' + data.message + ' : ' + getCookie('userMail'));

                        } else {


                            setAllCommentsOriginal(data);

                            if(commentsFilterType === 'all'){
                                setAllComments(data);

                                if(reloaded){
                                    THREEController.removeDecals();
                                    data.map(comment => {

                                        THREEController.makeCommentOnPack(comment.position,setCurrentNewCommentCount,comment.number,getCommentColorByStatus(comment.status.status));
                                    });
                                }

                            } else {
                                var newArray=[];
                                data.map(comment => {

                                    if(comment.status.status === "open" || comment.status.status === "new"){
                                        newArray.push(comment);
                                    }
                                });

                                setAllComments(newArray);

                                if(reloaded){
                                    THREEController.removeDecals();
                                    newArray.map(comment => {


                                        THREEController.makeCommentOnPack(comment.position,setCurrentNewCommentCount,comment.number,getCommentColorByStatus(comment.status.status) );
                                    });
                                }

                            }



                        }
                    });
            }


        } else {
            fetch(process.env.NEXT_PUBLIC_OBALERO_API_BASEPATH + 'corrections/version/' + versionUUID, {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    Authorization: 'Bearer ' + userTeamState, // notice the Bearer before your token
                },
            })
                .then(response => response.json())
                .then(function (data) {

                    if (data.message !== undefined) {
                        if(data.error_code !== "API_SUBSCRIPTION_UPGRADE_REQUIRED"){
                            Sentry.captureException('corrections/version/' +versionUUID + ': ' + data.message + ' : ' + getCookie('userMail'));

                        }

                    } else {


                        setAllCommentsOriginal(data);

                        if(commentsFilterType === 'all'){
                            setAllComments(data);
                            if(reloaded){
                                THREEController.removeDecals();
                                data.map(comment => {

                                    THREEController.makeCommentOnPack(comment.position,setCurrentNewCommentCount,comment.number,getCommentColorByStatus(comment.status.status));
                                });
                            }

                        } else {
                            var newArray=[];

                            data.map(comment => {
                                if(comment.status.status === "open" || comment.status.status === "new"){
                                    newArray.push(comment);
                                }
                            });
                            setAllComments(newArray);

                            if(reloaded){
                                THREEController.removeDecals();
                                newArray.map(comment => {

                                    THREEController.makeCommentOnPack(comment.position,setCurrentNewCommentCount,comment.number, getCommentColorByStatus(comment.status.status) );
                                });
                            }
                        }


                    }


                });
        }


    };

    const setLoadedOpenings = () => {
        setOpeningsLoaded(true);
    }
    const [packageOpeningsCount, setPackageOpeningsCount] = useState(0);

    const setLoadedOpeningsCount = (totalOpenings, openingCount) => {
        setOpeningsLoaded(true);
console.log("total openings, ", totalOpenings);
        console.log("openingCount, ", (openingCount+2));
        if((openingCount+2) === totalOpenings){
            console.log("close loading init");
            closeLoadingInit();
        }

    }
    const [packageOpenings, setPackageOpenings] = useState([]);
    const packageOpeningsRef = useRef([]); // Nebo useRef(null);

    const loadPackageOpenings = packageUUID => {
        fetch(process.env.NEXT_PUBLIC_OBALERO_API_BASEPATH + 'packages/' + packageUUID + '/openings', {
            method: 'GET',
            headers: {
                'Content-type': 'application/json',
                Authorization: 'Bearer ' + userTeamState, // notice the Bearer before your token
            },
        })
            .then(response => response.json())
            .then(function (data) {

                if (data.message !== undefined) {
                    Sentry.captureException('packages/' + packageUUID + '/openings' + ': ' + data.message + ' : ' + getCookie('userMail'));
                } else {
                    if(data.length > 1){
                        console.log("SET CAN DO. ", canDoOpeningType, data);
                        setCanDoOpeningType(true);
                        setPackageOpenings(data);
                        packageOpeningsRef.current = data;
                    }


                    // 1. Spočítej, kolik modelů se má *skutečně* načíst
                    const modelsToLoad = data.filter(openingItem =>
                        openingItem.name !== "No opening" && openingItem.name !== openingModelName
                    );
                    const numberOfModelsToLoad = modelsToLoad.length;

                    console.log("Aktuální openingModelName:", openingModelName);
                    console.log("Modely ke skutečnému načtení:", modelsToLoad.map(item => item.name));
                    console.log("Celkový počet modelů k načtení:", numberOfModelsToLoad);

                    // Pokud není co načítat (např. je tam jen "No opening" a/nebo již vybraný model)
                    if (numberOfModelsToLoad === 0) {
                        console.log("Žádné nové modely k načtení.");
                        setOpeningsLoaded(true); // Vše je "načteno"
                        closeLoadingInit();      // Zavři načítací indikátor
                        return; // Ukonči funkci
                    }

                    // 2. Inicializuj čítač načtených modelů
                    let loadedCounter = 0;

                    // 3. Definuj callback funkci pro úspěšné načtení JEDNOHO modelu
                    const handleSingleOpeningLoaded = () => {
                        loadedCounter++;
                        console.log(`Model načten. Stav: ${loadedCounter} / ${numberOfModelsToLoad}`);

                        // Nastav globální stav načítání (můžeš zvážit, zda to nedělat až po načtení všech)
                       // Nebo lépe: setOpeningsLoaded(loadedCounter / numberOfModelsToLoad * 100); pro progress?

                        // 4. Zkontroluj, zda jsou načteny všechny potřebné modely
                        if (loadedCounter === numberOfModelsToLoad) {
                            setOpeningsLoaded(true);
                            console.log("Všechny potřebné modely byly načteny. Zavírám loading init.");
                            closeLoadingInit();
                        }
                    };

                    // 5. Spusť načítání pro každý potřebný model
                    console.log("Spouštím načítání modelů...");
                    // Použijeme pole `modelsToLoad`, které už obsahuje jen ty správné položky
                    modelsToLoad.forEach(openingItem => {
                        console.log("Požadavek na načtení pro:", openingItem.name);

                        // setTimeout můžeš nechat, pokud řeší nějaký problém, ale zvaž, zda je nutný.
                        // THREEController.loadNewOpeningModel by měl být ideálně asynchronní sám o sobě.

                            THREEController.loadNewOpeningModel(
                                openingItem.thumbnail.opening_model,
                                100,
                                handleSingleOpeningLoaded // Předáme nový callback
                                // Už nepotřebujeme posílat délku pole ani index
                            );

                    });

                    // --- Konec nové logiky ---
                    /*
                    console.log("load openings", data);
                    setPackageOpenings(data);
                    data.map((openingItem, index, array) => {
                        const dataLength = array.length; // Získáme délku celého pole 'data'
                        const currentIndex = index;      // Získáme aktuální index
                        console.log("map probiha ",openingItem.name,openingModelName );
                        if (openingItem.name !== openingModelName && openingItem.name !== "No opening") {
                            console.log("jsme uvnitr mapu ",openingItem.name,openingModelName );
                            setTimeout(function() {
                                THREEController.loadNewOpeningModel(openingItem.thumbnail.opening_model, 100, setLoadedOpeningsCount, dataLength, currentIndex );
                            },200);

                        }
                    });*/
                }



            });
    };
    ///////////////////////// RENDERING END
    ///////////////////////// RENDERING END


    const [openingColors, setOpeningColors] = useState([]);

    const [activeColorChoose, setActiveColorChoose] = useState('tabs');

    const [shellColors, setShellColors] = useState([]);
    const [tabsColors, setTabsColors] = useState([]);

    const [bottleColors, setBottleColors] = useState([]);
    const [bodyColors, setBodyColors] = useState([]);
    const [fluidColors, setFluidColors] = useState([]);


    const [matteDesignOnUUID, setMatteDesignOnUUID] = useState('');
    const [matteDesignOffUUID, setMatteDesignOffUUID] = useState('');

    const [canDoMetallic, setCanDoMetallic] = useState(false);
    const [canDoRotateSides, setCanDoRotateSides] = useState(false);
    const [canDoAlpha, setCanDoAlpha] = useState(false);
    const [canDoBottleColor, setCanDoBottleColor] = useState(false);
    const [canDoMatte, setCanDoMatte] = useState(false);
    const [canDoFluidColor, setCanDoFluidColor] = useState(false);
    const [canDoBodyColor, setCanDoBodyColor] = useState(false);
    const [canDoShellColor, setCanDoShellColor] = useState(false);
    const [canDoTabsColor, setCanDoTabsColor] = useState(false);

    const [canDoFrontFaceRotation, setCanDoFrontFaceRotation] = useState(false);



    const [canDoOpeningType, setCanDoOpeningType] = useState(false);
    const [canDoOpeningColor, setCanDoOpeningColor] = useState(false);




    const [packageType, setPackageType] = useState('');

    const [packageDescription, setPackageDescription] = useState('');
    const [adobeIlustratorLink, setAdobeIlustratorLink] = useState(null);

    const [defaultValueMainDesign, setDefaultValueMainDesign] = useState(null);
    const [defaultValueAlphaDesign, setDefaultValueAlphaDesign] = useState(null);

    const [defaultValueMetallicDesign, setDefaultValueMetallicDesign] = useState(null);





    const [defaultValueMainDesignUUID, setDefaultValueMainDesignUUID] = useState(null);
    const [defaultValueAlphaDesignUUID, setDefaultValueAlphaDesignUUID] = useState(null);
    const [defaultValueMetallicDesignUUID, setDefaultValueMetallicDesignUUID] = useState(null);


    const [shrinkType, setShrinkType] = useState('');

    const [shrinkColumns, setShrinkColumns] = useState([]);
    const [shrinkRows, setShrinkRows] = useState([]);

    const [sideARotation, setSideARotation] = useState(null);
    const [sideBRotation, setSideBRotation] = useState(null);
    const [sideCRotation, setSideCRotation] = useState(null);
    const [sideDRotation, setSideDRotation] = useState(null);

    //////////////////////////// DATA FUNCTIONS AND LOADINGS



    const [alertTypeEditor, setAlertTypeEditor] = useState("warning");
    const [wrongEditorMessage, setWrongEditorMessage] = useState(null);
    // useEffect(() => {
    //
    //    setTeamCreditsInner(teamCredits);
    // }, [teamCredits]);

    let handleClickEditorMessage = () => {

    };
    let handleClickEditorMessage2 = () => {

    };


    let triggerWarning = (message) => {
        setAlertTypeEditor("warning");
        handleClickEditorMessage2();
        setWrongEditorMessage(message);
    };

    let triggerAlert = (message) => {
        setAlertTypeEditor("information");
        handleClickEditorMessage2();
        setWrongEditorMessage(message);
    };

    let handleClickDeleteComment = () => {

    };


    const [correctionDeleteUUID, setCorrectionDeleteUUID] = useState(null);


    let triggerDeleteComment = (correction) => {

        setCorrectionDeleteUUID(correction);
       handleClickDeleteComment();
    };



    const [windowEditorType, setWindowEditorType] = useState('illustrator');
    let handleWindowEditor = (type, typeTexture) => {
        setUploadedTextureType(typeTexture);
        setWindowEditorType(type);
        handleClickEditor();

        //triggerAlert("In order to work design properly, you need to set the alpha map");
    };

    const [displayCanvasThumbnail, setDisplayCanvasThumbnail] = useState(false);

    let handleWindowInsideProductsShrink = type => {

        setDisplayCanvasThumbnail(true);
        handleClickInsideShrinkProducts();
    };
    let handleClickInsideShrinkProducts = () => {
        document.getElementById('c').style.display = 'block';

    };

    let handleClickEditor = () => {

    };
    let handleFinishUploadWindow = () => {

    };

    const [dialogEditorType, setDialogEditorType] = useState({});

    const [productsInsideShrinkAvailable, setProductsInsideShrinkAvailable] = useState({});
    const [selectedProductInside, setSelectedProductInside] = useState(null);

    const [urlProductsInside, setURLProductsInside] = useState(null);
    const [versionUUIDShrinkInside, setVersionUUIDShrinkInside] = useState(null);

    const [productInsideShrinkName, setProductInsideShrinkName] = useState('No product');
    const [parentUUIDShrinkInside, setParentUUIDShrinkInside] = useState(null);


    const [isShrink, setIsShrink] = useState(null);
    const [isCarton, setIsCarton] = useState(null);


    const setProductInsideShrinkAPI = (uuidVersion, productName) => {

        fetch(process.env.NEXT_PUBLIC_OBALERO_API_BASEPATH + 'products/' + masterProductUUID + '/versions/' + versionProductUUID, {
            method: 'PUT',
            body: JSON.stringify({
                product_version_inside: uuidVersion,
            }),
            headers: {
                'Content-type': 'application/json',
                Authorization: 'Bearer ' + userTeamState, // notice the Bearer before your token
            },
        })
            .then(response => response.json())
            .then(function (data) {
                if (data.message !== undefined) {
                    Sentry.captureException('productsProductInside/' + masterProductUUID + '/versions/' + versionProductUUID + ': ' + data.message + ' : ' + getCookie('userMail'));
                } else {
                    setURLProductsInside(data.data.product_version_inside.options['main-design']);

                    THREEController.loadTexturesInside(data.data.product_version_inside.options['main-design']);

                    setVersionUUIDShrinkInside(data.data.product_version_inside.uuid);

                    var string = data.data.product_version_inside.parent.name;
                    var trimmedString = string;
                    if (string.length > 10) {
                        trimmedString = string.substring(0, 10) + '...';
                    }

                    THREEController.takeScreenshot(masterProductUUID, versionProductUUID,setLoadProductsShow, false, allComments,commentActive);
                    setProductInsideShrinkName(trimmedString);
                    setParentUUIDShrinkInside(data.data.product_version_inside.parent.uuid);
                }

                setLoadTransitionProductsShowUI(false);
                setTimeout(function () {
                    setLoadProductsShowVariableUI(false);
                }, 1000);
            });
    };


    // useEffect(() => {
    //
    //    setTeamCreditsInner(teamCredits);
    // }, [teamCredits]);

    const makeScreenshot = () => {
        THREEController.takeScreenshot(masterProductUUID, versionProductUUID,setLoadProductsShow,true, allComments,commentActive);
    }
    const setProductInsideShrinkRotationAPI = uuidVersion => {

        fetch(process.env.NEXT_PUBLIC_OBALERO_API_BASEPATH + 'products/' + masterProductUUID + '/versions/' + versionProductUUID, {
            method: 'PUT',
            body: JSON.stringify({
                product_version_inside_rotation: THREEController.productVersionInsideRotationInner,
            }),
            headers: {
                'Content-type': 'application/json',
                Authorization: 'Bearer ' + userTeamState, // notice the Bearer before your token
            },
        })
            .then(response => response.json())
            .then(function (data) {
                if (data.message !== undefined) {
                    Sentry.captureException('productsProductInside/' + masterProductUUID + '/versions/' + versionProductUUID + ': ' + data.message + ' : ' + getCookie('userMail'));
                }

                //
                THREEController.takeScreenshot(masterProductUUID, versionProductUUID,setLoadProductsShow, false, allComments,commentActive);
                cancelRotationMode();
                setLoadTransitionProductsShowUI(false);
                setTimeout(function () {
                    setLoadProductsShowVariableUI(false);
                }, 1000);
            });
    };


    const [productInsideShrinkProductType, setProductInsideShrinkProductType] = useState(null);
    const [productInsideShrinkVolume, setProductInsideShrinkVolume] = useState(null);
    const [productDefaultMetallicDesign, setProductDefaultMetallicDesign] = useState(null);

    const loadEditorDataAPI = () => {
if(slugState){

    fetch(process.env.NEXT_PUBLIC_OBALERO_API_BASEPATH + 'editor/' + slugState, {
        method: 'GET',
        headers: {
            'Content-type': 'application/json',
            Authorization: 'Bearer ' + userTeamState, // notice the Bearer before your token
        },
    })
        .then(response => response.json())
        .then(function (data) {
            if (data.message !== undefined) {
                Sentry.captureException('editor/' + slugState + ': ' + data.message + ' : ' + getCookie('userMail'));
            }
            if (data.status === 403) {

                if(data.error_code){

                    setWrongEditorMessage(data.error_code);
                } else {
                    setWrongEditorMessage(data.message);
                }

                handleClickEditorMessage();
            }

            if (data.status === 404) {

                if(data.error_code){
                    setWrongEditorMessage(data.error_code);
                } else {
                    setWrongEditorMessage(data.message);
                }


                handleClickEditorMessage();

            }


            var token2 = getCookie('userTeam');
            var tokenMain = getCookie('userTeam');
            if (plugin) {
                tokenMain = getCookie('pluginLoginSessionToken');
                token2 = getCookie('pluginLoginSessionTeamToken');
            }

            if (data.switch_to_team) {
                fetch(process.env.NEXT_PUBLIC_OBALERO_API_BASEPATH + 'auth/switch-team/' + data.switch_to_team, {
                    method: 'POST',
                    headers: {
                        'Content-type': 'application/json',
                        Authorization: 'Bearer ' + tokenMain, // notice the Bearer before your token
                    },
                })
                    .then(response => response.json())
                    .then(function (data2) {

                        if (data2.message !== undefined) {
                            Sentry.captureException('auth/switch-team/' + data.switch_to_team + ': ' + data.message + ' : ' + getCookie('userMail'));
                        } else {

                            setCookie('userTeamUUID', data.switch_to_team, {maxAge: 10 * 365 * 24 * 60 * 60} );
                            setCookie('pluginLoginSessionTeamToken', data2.token, { maxAge: 10 * 365 * 24 * 60 * 60 });
                            setCookie('userTeam', data2.token, { maxAge: 10 * 365 * 24 * 60 * 60 });

                            window.open(window.location.pathname, '_self');
                        }
                    });
            }


            if (data.message === undefined) {

                if(data.product.can_be_rendered){
                    if(setCanBeRendered){
                        setCanBeRendered(data.product.can_be_rendered);
                    }

                }
                if(data.mode){
                    changeEditorUserMode(data.mode);
                    changeEditorMode(data.mode);

                    if(setUserRole){
                        setUserRole(prev => ({
                            ...prev,
                            userRole: data.mode,
                        }));

                    }

                }
                setVersionIsLocked(data.locked.locked);
                setBodyModel(data.product.package.models.web);

                if (data.product.opening.models.web !== null) {
                    setOpeningModel(data.product.opening.models.web);
                } else {
                    setOpeningModel('neniModel');
                }

                if (setProductNameMaster) {
                    setProductNameMaster(data.product.name + ' / ' + data.product.package.volume + ' ml / ');
                }
                if (setProductVersionNameMaster) {
                    setProductVersionNameMaster(data.product.version);
                }

                if (setBreadcrumbs) {
                    setBreadcrumbs(data.breadcrumbs);
                }

                setPackageOpeningUUID(data.product.opening.uuid);
                setPackageOpeningName(data.product.opening.name);

                setOpeningID(data.product.opening.description);
                setRenderModelOpening(data.product.opening.models.render);
                setRenderModelBody(data.product.package.models.render);

                setMasterProductUUID(data.product.master_product_uuid);
                setVersionProductUUID(data.product.uuid);
                setOpeningModelName(data.product.opening.name);

                setProductName(data.product.name);
                setProductVersionName(data.product.version);
                setProductSize(data.product.package.volume);
                setProductPackage(data.product.package.groups[0].name);

                setTemplateWidth(data.product.package.design_width);
                setTemplateHeight(data.product.package.design_height);
                if (data.product.package.groups[0].name === 'Cans Sleek' || data.product.package.groups[0].name === 'Cans Standard' || data.product.package.groups[0].name === 'Cans Slim') {
                    setPackageType('cans');
                    setIsShrink(false);
                } else if (data.product.package.groups[0].name === 'Doypacks' || data.product.package.groups[0].name === "Doypacky PPF" || data.product.package.groups[0].name === "Doypacky") {
                    setPackageType('doypacks');
                } else if (
                    data.product.package.name === 'Shrink Foil Cans 4x500ml' ||
                    data.product.package.name === 'Shrink Foil Cans 6x500ml' ||
                    data.product.package.name === 'Shrink Foil Cans UV 6x500ml' ||
                    data.product.package.name === 'Shrink Foil Cans 8x500ml' ||
                    data.product.package.name === 'Shrink Foil Cans 12x500ml'
                ) {
                    if (data.product.package.name === 'Shrink Foil Cans 4x500ml') {
                        setShrinkType('4');

                        var newShrinkColumns = [];
                        var newShrinkRows = [];

                        for (let i = 0; i < 2; i++) {
                            newShrinkColumns.push(i);
                        }

                        for (let i = 0; i < 2; i++) {
                            newShrinkRows.push(i);
                        }

                        setShrinkColumns(newShrinkColumns);
                        setShrinkRows(newShrinkRows);
                    } else if (data.product.package.name === 'Shrink Foil Cans 6x500ml') {
                        setShrinkType('6');

                        var newShrinkColumns = [];
                        var newShrinkRows = [];

                        for (let i = 0; i < 3; i++) {
                            newShrinkColumns.push(i);
                        }

                        for (let i = 0; i < 2; i++) {
                            newShrinkRows.push(i);
                        }

                        setShrinkColumns(newShrinkColumns);
                        setShrinkRows(newShrinkRows);
                    } else if (data.product.package.name === 'Shrink Foil Cans UV 6x500ml') {
                        setShrinkType('6');
                        var newShrinkColumns = [];
                        var newShrinkRows = [];

                        for (let i = 0; i < 3; i++) {
                            newShrinkColumns.push(i);
                        }

                        for (let i = 0; i < 2; i++) {
                            newShrinkRows.push(i);
                        }

                        setShrinkColumns(newShrinkColumns);
                        setShrinkRows(newShrinkRows);
                    } else if (data.product.package.name === 'Shrink Foil Cans 8x500ml') {
                        setShrinkType('8');
                        var newShrinkColumns = [];
                        var newShrinkRows = [];

                        for (let i = 0; i < 4; i++) {
                            newShrinkColumns.push(i);
                        }

                        for (let i = 0; i < 2; i++) {
                            newShrinkRows.push(i);
                        }

                        setShrinkColumns(newShrinkColumns);
                        setShrinkRows(newShrinkRows);
                    } else if (data.product.package.name === 'Shrink Foil Cans 12x500ml') {
                        setShrinkType('12');
                        var newShrinkColumns = [];
                        var newShrinkRows = [];

                        for (let i = 0; i < 4; i++) {
                            newShrinkColumns.push(i);
                        }

                        for (let i = 0; i < 3; i++) {
                            newShrinkRows.push(i);
                        }

                        setShrinkColumns(newShrinkColumns);
                        setShrinkRows(newShrinkRows);
                    }

                    setPackageType('shrinks');
                    setIsShrink(true);

                    if (
                        data.product.inside &&
                        data.product.inside.product_version &&
                        (data.product.inside.product_version.message == undefined || data.product.inside.product_version.message == null)
                    ) {
                        setURLProductsInside(data.product.inside.product_version.options['main-design']);
                        setVersionUUIDShrinkInside(data.product.inside.product_version.uuid);
                        var string = data.product.inside.product_version.parent.name;
                        var trimmedString = string;
                        if (string.length > 7) {
                            trimmedString = string.substring(0, 7) + '...';
                        }
                        setProductInsideShrinkName(trimmedString);
                        setParentUUIDShrinkInside(data.product.inside.product_version.parent.uuid);
                        setProductVersionInsideRotation(data.product.inside.rotations);
                    }
                    if (data.product.inside.product_version && data.product.inside.product_version.message) {
                        setWrongEditorMessage(data.product.inside.product_version.message);
                        handleClickEditorMessage2();
                    }
                    if (data.product.package.product_inside_package_group && data.product.package.product_inside_package_volume) {
                        setProductInsideShrinkProductType(data.product.package.product_inside_package_group.uuid);
                        setProductInsideShrinkVolume(data.product.package.product_inside_package_volume.uuid);
                    }
                } else if (data.product.package.groups[0].name === 'Doypacks' || data.product.package.groups[0].name === "Doypacky PPF" || data.product.package.groups[0].name === "Doypacky") {
                    setPackageType('doypacks');
                } else if (data.product.package.groups[0].name === 'Glass Bottles') {
                    setPackageType('glass-bottles');
                }
                else if (data.product.package.groups[0].name === 'Glass Bottles O-I') {
                    setPackageType('glass-bottles');
                }
                else if (data.product.package.groups[0].name === 'Glass Bottles Fruko') {
                    setPackageType('glass-bottles');
                }
                else if (data.product.package.groups[0].name === 'Glass Bottles Beer') {
                    setPackageType('glass-bottles');
                }
                else if (data.product.package.groups[0].name === 'NICKNACK Shot') {
                    setPackageType('drink-cups');
                }
                else if (data.product.package.groups[0].name === 'NICKNACK IML' || data.product.package.groups[0].name === 'NICKNACK HotCup SP' || data.product.package.groups[0].name === 'NICKNACK HotCup IML' || data.product.package.groups[0].name === 'NICKNACK SP') {
                    setPackageType('drink-cups');
                }else if (data.product.package.groups[0].name === 'Boxes' || data.product.package.groups[0].name === 'Propesko Boxes' || data.product.package.groups[0].name === 'Boxy' ) {
                    setPackageType('box');
                }
                else {
                    setPackageType('cartons');
                    setIsCarton(true);
                }
                if(data.product.package.description === "SPFRUKO 500 ml"){
                    setPackageDescription('SPFRUKO 500 ml');
                }
                if(data.product.package.description === "FBIT700"){
                    setPackageDescription('FBIT700');
                }
                log("data.product.package.description", data.product.package.description);
                if(data.product.package.description === "SPFRUKO Kapalina 500ml"){
                    setPackageDescription('SPFRUKO 500ml Kapalina');
                }


                setAdobeIlustratorLink(data.download_links.illustrator);

                setAllMenuLevelsActions(data.actions);
                setDrawingLinks(data.download_links);

                if(data.share){
                    setSharedUsers(data.share.users);
                }

                setUserSelectedOptionsVar(data.product.options);
                setEditorScenes(EditorData.scenes);


                setCurrentPackageUUID(data.product.package.uuid);

                let mainDesignValuesArr = [];

                let alphaDesignValuesArr = [];
                let metallicDesignValuesArr = [];

                let shellColorsArr = [];

                let openingColorsArr = [];

                let tabColorsArr = [];
                let bottleColorsArr = [];
                let bodyColorsArr = [];
                let fluidColorsArr = [];


                var frontFaceAngle = 0;
                let productsNew = [
                    ...data.actions.map(item => {
                        if (item.key === 'body') {
                            item.actions.map(itemActions => {
                                if (itemActions.key === 'main-design') {
                                    mainDesignValuesArr = itemActions.values;

                                    itemActions.values.map(itemActionsValues => {

                                        if (itemActionsValues.uuid === itemActions.default_value) {
                                            setDefaultValueMainDesignUUID(itemActionsValues.uuid);

                                            setDefaultValueMainDesign(itemActionsValues.value);
                                        }
                                    });
                                }

                                if (itemActions.key === 'alpha-design') {
                                    setCanDoAlpha(true);
                                    alphaDesignValuesArr = itemActions.values;

                                    itemActions.values.map(itemActionsValues => {

                                        if (itemActionsValues.uuid === itemActions.default_value) {

                                            setDefaultValueAlphaDesignUUID(itemActionsValues.uuid);

                                            setDefaultValueAlphaDesign(itemActionsValues.value);
                                        }
                                    });
                                }

                                if (itemActions.key === 'metallic-design') {
                                    setCanDoMetallic(true);
                                    metallicDesignValuesArr = itemActions.values;

                                    itemActions.values.map(itemActionsValues => {

                                        if (itemActionsValues.uuid === itemActions.default_value) {
                                            setDefaultValueMetallicDesignUUID(itemActionsValues.uuid);
                                            setDefaultValueMetallicDesign(itemActionsValues.value);
                                        }
                                    });
                                }

                                if (itemActions.key === 'matte-design') {
                                    setCanDoMatte(true);
                                    setMatteDesignOffUUID(itemActions.values[0].uuid);
                                    setMatteDesignOnUUID(itemActions.values[1].uuid);
                                }


                                if (itemActions.key === 'frontface-angle') {
                                    setCanDoFrontFaceRotation(true);
                                }
                                if (itemActions.key === 'frontface-angle-sides') {
                                    setCanDoRotateSides(true);
                                    if (itemActions.values[0]) {
                                        setSideARotation(itemActions.values[0]);
                                    }
                                    if (itemActions.values[1]) {
                                        setSideBRotation(itemActions.values[1]);
                                    }
                                    if (itemActions.values[2]) {
                                        setSideCRotation(itemActions.values[2]);
                                    }
                                    if (itemActions.values[3]) {
                                        setSideDRotation(itemActions.values[3]);
                                    }
                                }

                                if (itemActions.key === 'body-color') {
                                    setCanDoBodyColor(true);
                                    bodyColorsArr = itemActions.values;
                                }
                                if (itemActions.key === 'bottle-color') {
                                    setCanDoBottleColor(true);
                                    bottleColorsArr = itemActions.values;
                                }
                                if (itemActions.key === 'fluid-color') {
                                    setCanDoFluidColor(true);
                                    fluidColorsArr = itemActions.values;
                                }
                                if (itemActions.key === 'opening-type') {
                                 //   setCanDoOpeningType(true);
                                }
                            });





                        }

                        if (item.key === 'shell') {
                            item.actions.map(itemActions => {
                                if (itemActions.key === 'shell-color') {
                                    setCanDoShellColor(true);
                                    shellColorsArr = itemActions.values;
                                }
                            });
                        }
                        if (item.key === 'tab') {
                            item.actions.map(itemActions => {
                                if (itemActions.key === 'tabs-color') {
                                    setCanDoTabsColor(true);
                                    tabColorsArr = itemActions.values;
                                }
                            });
                        }
                        if (item.key === 'opening') {
                            item.actions.map(itemActions => {
                                if (itemActions.key === 'opening-color') {
                                    setCanDoOpeningColor(true);
                                    openingColorsArr = itemActions.values;
                                }

                            });
                        }
                    }),
                ];

                setMainDesignValues(mainDesignValuesArr);
                setAlphaDesignValues(alphaDesignValuesArr);

                setShellColors(shellColorsArr);
                setTabsColors(tabColorsArr);
                setBottleColors(bottleColorsArr);
                setBodyColors(bodyColorsArr);


                setFluidColors(fluidColorsArr);

                setOpeningColors(openingColorsArr);
                openingColorsRef.current = openingColorsArr;

                setLoadingProgressSentence('loading');

                setLoadingProgressPercent(20);

            } else {

                if(data.error_code){

                    setWrongEditorMessage(data.error_code);
                } else {
                    setWrongEditorMessage(data.message);
                }


                handleClickEditorMessage();
            }
        });
}

    };





    const updateOptionAPI = (actionKey, value, uuid) => {
        log("UPDATE ", actionKey,value);
        fetch(process.env.NEXT_PUBLIC_OBALERO_API_BASEPATH + 'products/' + masterProductUUID + '/versions/' + versionProductUUID, {
            method: 'PUT',
            body: JSON.stringify({
                options: {
                    [actionKey]: value,
                },
            }),
            headers: {
                'Content-type': 'application/json',
                Authorization: 'Bearer ' + userTeamState, // notice the Bearer before your token
            },
        })
            .then(response => response.json())
            .then(function (data) {
                if (data.message !== undefined) {
                    Sentry.captureException('products/' + masterProductUUID + '/versions/' + versionProductUUID + ': ' + data.message + ' : ' + getCookie('userMail'));
                }
                if (data.message === undefined) {
                    handleFinishUploadWindow();

                    setDesignPopupOpened(false);
                    setMetalnessPopupOpened(false);
                    setAlphaPopupOpened(false);
                } else {
                }
                setLoadTransitionProductsShowUI(false);
                setTimeout(function () {
                    setLoadProductsShowVariableUI(false);
                }, 1000);
            });
    };

    const getDefaultOptionValueFromKey = key => {
        var okey = 'okeydeafult';
        allEditorMenuActions.map((value, index) => {
            value.actions.map((valueActions, indexActions) => {
                if (valueActions.key === key) {
                    okey = valueActions.default_value;
                }
            });
        });

        return okey;
    };
    const getOptionNameFromUUID = uuid => {
        var okey = 'okeydeafult';


        allEditorMenuActions.map((value, index) => {
            value.actions.map((valueActions, indexActions) => {
                valueActions.values.map((valueActionsValues, indexActionsValues) => {
                    if (valueActionsValues.uuid === uuid) {
                        okey = valueActionsValues.name;
                    }
                });
            });
        });
        return okey;
    };
    const getOptionValueFromUUID = uuid => {
        var okey = 'okeydeafult';


        allEditorMenuActions.map((value, index) => {
            value.actions.map((valueActions, indexActions) => {
                valueActions.values.map((valueActionsValues, indexActionsValues) => {
                    if (valueActionsValues.uuid === uuid) {
                        okey = valueActionsValues.value;
                    }
                });
            });
        });
        return okey;
    };
    const getOptionURLFromUUID = uuid => {
        var okey = 'okeydeafult';

        allEditorMenuActions.map((value, index) => {
            value.actions.map((valueActions, indexActions) => {
                valueActions.values.map((valueActionsValues, indexActionsValues) => {
                    if (valueActionsValues.uuid == uuid) {
                        okey = valueActionsValues.url;
                    }
                });
            });
        });
        return okey;
    };

    const switchMatteDesignFun = value => {
        if (value) {
            doAction(null, 'matte-design', matteDesignOffUUID);
        } else {
            doAction(null, 'matte-design', matteDesignOnUUID);
        }
    };

    const doAction = (e, key, uuid, name) => {
        setTypeLoading("action");
        setLoadProductsShow(true);


        if (key !== 'addNewTexture') {
            if (key === 'frontface-angle-sides') {
                fetch(process.env.NEXT_PUBLIC_OBALERO_API_BASEPATH + 'products/' + masterProductUUID + '/versions/' + versionProductUUID, {
                    method: 'PUT',
                    body: JSON.stringify({
                        options: {
                            'frontface-angle-sides': uuid.value,
                        },
                    }),
                    headers: {
                        'Content-type': 'application/json',
                        Authorization: 'Bearer ' + userTeamState, // notice the Bearer before your token
                    },
                })
                    .then(response => response.json())
                    .then(function (data) {
                        if (data.message !== undefined) {
                            Sentry.captureException('products/' + masterProductUUID + '/versions/' + versionProductUUID + ': ' + data.message + ' : ' + getCookie('userMail'));
                        }


                        if (data.message === undefined) {
                            setDesignPopupOpened(false);
                            setMetalnessPopupOpened(false);

                            THREEController.rotateProductDefault(uuid.value, packageType === 'shrinks' ? true : false);

                           // THREEController.takeScreenshot(masterProductUUID, versionProductUUID,setLoadProductsShow, false, allComments,commentActive);

                            if (
                                data.data.updated_actions['frontface-angle-sides'].values[0] &&
                                data.data.updated_actions['frontface-angle-sides'].values[0].uuid === data.data.updated_options['frontface-angle-sides']
                            ) {

                                setSideRotationChecked(data.data.updated_actions['frontface-angle-sides'].values[0].uuid);
                            }

                            if (
                                data.data.updated_actions['frontface-angle-sides'].values[1] &&
                                data.data.updated_actions['frontface-angle-sides'].values[1].uuid === data.data.updated_options['frontface-angle-sides']
                            ) {
                                setSideRotationChecked(data.data.updated_actions['frontface-angle-sides'].values[1].uuid);
                            }
                            if (
                                data.data.updated_actions['frontface-angle-sides'].values[2] &&
                                data.data.updated_actions['frontface-angle-sides'].values[2].uuid === data.data.updated_options['frontface-angle-sides']
                            ) {
                                setSideRotationChecked(data.data.updated_actions['frontface-angle-sides'].values[2].uuid);
                            }
                            if (
                                data.data.updated_actions['frontface-angle-sides'].values[3] &&
                                data.data.updated_actions['frontface-angle-sides'].values[3].uuid === data.data.updated_options['frontface-angle-sides']
                            ) {
                                setSideRotationChecked(data.data.updated_actions['frontface-angle-sides'].values[3].uuid);
                            }
                        } else {
                        }
                        setLoadTransitionProductsShowUI(false);
                        setTimeout(function () {
                            setLoadProductsShow(false);

                            setLoadProductsShowVariableUI(false);
                        }, 500);
                    });

                setAngleRotateOriginal(angleRotate);
            }

            if (key === 'frontface-angle') {
                updateOptionAPI(key, uuid, uuid);

                setAngleRotateOriginal(angleRotate);


                setRotationMode(false);
            }

            if (key === 'opening-color') {
                updateOptionAPI(key, getOptionValueFromUUID(uuid), uuid);
            }
            if (key === 'body-color') {
                updateOptionAPI(key, getOptionValueFromUUID(uuid), uuid);
            }

            if (key === 'shell-color') {
                updateOptionAPI(key, getOptionValueFromUUID(uuid), uuid);
            }

            if (key === 'tabs-color') {
                updateOptionAPI(key, getOptionValueFromUUID(uuid), uuid);
            }
            if (key === 'bottle-color') {
                updateOptionAPI(key, getOptionValueFromUUID(uuid), uuid);
            }
            if (key === 'fluid-color') {
                updateOptionAPI(key, getOptionValueFromUUID(uuid), uuid);
            }
            if (key === 'main-design') {
                if (mainDesignValues.length > 1) {
                    updateOptionAPI(key, getOptionValueFromUUID(uuid), uuid);
                } else {
                    setLoadTransitionProductsShowUI(false);
                    setLoadProductsShowVariableUI(false);
                }
            }

            if (key === 'alpha-design') {
                updateOptionAPI(key, getOptionValueFromUUID(uuid), uuid);
            }


            if (key === 'metallic-design') {
                updateOptionAPI(key, getOptionValueFromUUID(uuid), uuid);
            }


            if (key === 'matte-design') {
                updateOptionAPI(key, getOptionValueFromUUID(uuid), uuid);
            }
        } else {
        }

   /*     setTimeout(function(){
            setLoadProductsShow(false);
        },800);*/

    };

    const loadModels = () => {
        var newOpening = null;
        if (openingModel !== 'neniModel') {
            newOpening = openingModel;
        }

        var loadingModels = THREEController.loadModel(
            bodyModel,
            newOpening,
            function (openingYX) {

                setOpeningY(openingYX);

                setTimeout(function () {
                    THREEController.setUpRulers(false, setIsModelLoadedMain, packageType);

                    setAllModelsLoaded(true);

                    setLoadingProgressPercent(50);
                    setReloadTextures(true);

                    if(urlProductsInside){

                        THREEController.loadTexturesInside(urlProductsInside);
                    }

                    setTimeout(function () {

                        if (rulerButtonChecked) {
                            THREEController.ToggleRulers(true);
                        } else {
                            THREEController.ToggleRulers(false);
                        }
                    }, 1500);
                }, 1500);
            },
            1,
            'normal',packageType,packageDescription
        );
    };

    const setIsModelLoadedMain = () => {
        setLoadingProgressPercent(90);
  /*      setTimeout(function () {
            setLoadingProgressPercent(90);
            setLoadProductsShow(false);
        }, 1500);*/
    };

    const closeLoadingInit = () => {
        setTimeout(function () {
            setLoadingProgressPercent(100);
            setLoadProductsShow(false);
        }, 1500);
    };

    const uploadNewTexture = type => {
console.log("upload new", type, uploadedTexture);
        fetch(process.env.NEXT_PUBLIC_OBALERO_API_BASEPATH + 'uploads/prepare-form', {
            method: 'GET',
            headers: {
                'Content-type': 'application/json',
                Authorization: 'Bearer ' + userTokenState, // notice the Bearer before your token
            },
        })
            .then(response => response.json())
            .then(function (data) {
                if (data.message !== undefined) {
                    Sentry.captureException('uploads/prepare-form' + ': ' + data.message + ' : ' + getCookie('userMail'));
                }


                let formData = new FormData();
                Object.keys(data.formInputs).forEach(key => {
                    formData.append(key, data.formInputs[key]);
                });
                formData.append('file', uploadedTexture);
                fetch(data.formAttributes.action, {
                    method: data.formAttributes.method,
                    /*    headers: {
                        'Content-type': data.formAttributes.enctype
                     },*/
                    body: formData,
                })
                    .then(function (dataUpload) {

                        var newType = "main-design";
                        if(alphaPopupOpened){
                            newType = "alpha-design";
                        }
                        if(metalnessPopupOpened){
                            newType = "metallic-design";
                        }

                        setUploadedTextureType(null);
                        setUploadedTexture(null);
                        updateOptionAPI(uploadedTextureType, data.formInputs.key);

                    })
                    .catch(function (e) {
                        Sentry.captureException(data.formAttributes.action + ': ' + e + ' : ' + getCookie('userMail'));
                    });
            });
    };


    const [loadingInited, setLoadingInited] = useState(false);
    useEffect(() => {
        if(!loadingInited){
            setLoadingInited(true);
            setTypeLoading("initMane");
        }

    }, [typeLoading]);


    useEffect(() => {

        if (uploadedTexture !== null && uploadedTextureType !== null) {
            uploadNewTexture(uploadedTextureType);
        }
    }, [uploadedTexture, uploadedTextureType]);

    //     //////////// SOCKETS
    const [socketInited, setSocketInited] = useState(false);
    useEffect(() => {

        if (versionProductUUID !== null && masterProductUUID !== null && userTokenState !== null && mainDesignValues.length > 0 && !socketInited) {
            setUpSockets();
            loadComments(versionProductUUID);
        }
    }, [versionProductUUID, masterProductUUID, userTokenState, mainDesignValues]);

    const [textureInitCountNumber, setTextureInitCountNumber] = useState(0);
    var neco = 0;
    const setTextureInitCount = () => {


        neco = neco+1;


    }

    const setUpSockets = () => {

        // if (socket !== undefined) {
        //
        //     socket.close();
        //     socket.disconnect();
        //     socket.emit('end');
        //     socket.offAny();
        //     socket.removeAllListeners();
        //     socket = null;
        // }

        if (socket) {

            socket.close();
            socket.disconnect();
            socket.emit('end');
            socket.offAny();
            socket.removeAllListeners();
            socket = null;
        }
        if (socketEditor ) {

            socketEditor.close();
            socketEditor.disconnect();
            socketEditor.emit('end');
            socketEditor.offAny();
            socketEditor.removeAllListeners();
            socketEditor = null;
        }

        if (socketComments) {

            socketComments.close();
            socketComments.disconnect();
            socketComments.emit('end');
            socketComments.offAny();
            socketComments.removeAllListeners();
            socketComments = null;
        }



        socketEditor = io(process.env.NEXT_PUBLIC_OBALERO_SOCKET_BASEPATH + 'editor/' + slugState, {
            transports: ['websocket'],
            auth: {
                token: userTeamState,
            },

        });

        socketEditor.on('connect', () => {

        });
        socketEditor.on('list_sanchez', () => {

        });
        socketEditor.onAny((event, ...args) => {
            setSocketInited(true);
            var isSuitableForScreenshot = false;
            var countAllTex = 0;
console.log("ON ANY ", event, args,  args[0]['opening'],packageOpeningsRef.current, packageOpenings,  args[0]);

            if (event === 'update'&&  args[0]['opening']){



                    setPackageOpeningUUID(args[0]['opening']);
                packageOpeningsRef.current.map(openingItem => {
                        if (openingItem.uuid === args[0]['opening']) {
                            console.log("nastavuju opening", openingItem, openingColorsRef.current);



                            var newColor = getOptionValueFromUUID(openingColorUUIDRef.current);
                            if (!openingColorRef.current) {
                                console.log("Barva víčka (openingColor) není nastavena. Pokouším se najít výchozí podle thumbnailu.");

                                // 2. Najdi první položku v openingColors, která odpovídá hodnotě v thumbnailu
                                const defaultColorItem = openingColorsRef.current.find(item =>
                                    item.value === openingItem.thumbnail.options["opening-color"]
                                );

                                // 3. Pokud byla nalezena odpovídající výchozí barva
                                if (defaultColorItem) {
                                    console.log(`Nalezena výchozí barva: ${defaultColorItem.name}, Hodnota: ${defaultColorItem.value}`);

                                    // Použij nalezenou hodnotu pro nastavení stavu
                                    const vysledek = oddelitBarvuAAlfu(defaultColorItem.value); // Použijeme hodnotu z nalezené položky

                                    setOpeningColor(vysledek.barva);
                                    openingColorRef.current =vysledek.barva;
                                    setOpeningColorName(getOptionNameFromUUID(defaultColorItem.uuid));
                                    setOpeningColorUUID(defaultColorItem.uuid);

                                    newColor = openingItem.thumbnail.options["opening-color"];

                                } else {
                                    console.log("Pro hodnotu z thumbnailu nebyla nalezena odpovídající výchozí barva:", openingItem.thumbnail.options["opening-color"]);

                                }

                            } else {
                                console.log("Barva víčka (openingColor) je již nastavena na:", openingColorRef.current, ". Přeskakuji přepis výchozí barvou.");
                            }
                            console.log("chang emodel", newColor);
                            setPackageOpeningName(openingItem.name);
                            THREEController.changeOpeningModelVisibility(openingItem.description, packageOpeningsRef.current, newColor);
                        }
                    });

                 setTimeout(function(){
                        THREEController.takeScreenshot(masterProductUUID, versionProductUUID,setLoadProductsShow, false, allComments,commentActive);
                    }, 35);


            }

                if (event === 'update'&&  args[0]['actions']){
                    if(args[0]['actions']&& args[0]['actions']["shell-color"]){
                        setShellColors(args[0]['actions']["shell-color"]["values"]);
                        setTimeout(function(){
                            THREEController.takeScreenshot(masterProductUUID, versionProductUUID,setLoadProductsShow, false, allComments,commentActive);
                        }, 35);
                    }
                    if(args[0]['actions']&& args[0]['actions']["tabs-color"]){
                        setTabsColors(args[0]['actions']["tabs-color"]["values"]);
                        setTimeout(function(){
                            THREEController.takeScreenshot(masterProductUUID, versionProductUUID,setLoadProductsShow, false, allComments,commentActive);
                        }, 35);
                    }

                }
            if (event === 'update_options' && args[0]['updated_options']['main-design']) {
                console.log("jedeme",  args[0]['updated_options']['main-design'] );
            }

                if (event === 'update_options' && args[0]['updated_options']['main-design'] !== undefined ) {
console.log("CHGABGE MAIN Desig",args[0]['updated_action_values']);

                if (args[0]['updated_action_values'].length === 0) {
                    console.log("CHGABGE MAIN Desig",args[0]['updated_action_values']);
                    setBodyMainTextureUUID(args[0]['updated_options']['main-design']);
                    setMainTextureBody(getOptionURLFromUUID(args[0]['updated_options']['main-design']));

                    var newTexture = "bodyMainTexture";

                    if(packageType === "glass-bottles"){
                        newTexture="bodyGBottleMainTexture";
                    }
                    if(packageType === "plastic-drink-cups"){
                        newTexture="bodyPlasticCupTexture";
                    }
                    if(packageType === "drink-cups"){
                        newTexture="bodyPlasticCupTexture";
                    }
                    console.log("newTexture",newTexture, getOptionURLFromUUID(args[0]['updated_options']['main-design']));
                    THREEController.changeTexture(newTexture, getOptionURLFromUUID(args[0]['updated_options']['main-design']), masterProductUUID, versionProductUUID, setTextureInitCount);
                    countAllTex++;
                } else {
                    console.log("CHGABGE MAIN Desig2222 ",args[0]['updated_action_values']['main-design']);
                    var newMainDesignValues = [];
                    newMainDesignValues.push(mainDesignValues[0]);
                    newMainDesignValues.push(args[0]['updated_action_values']['main-design'].value);

                    setMainDesignValues(newMainDesignValues);
                    setMainTextureBody(args[0]['updated_action_values']['main-design'].value.url);

                    setBodyMainTextureUUID(args[0]['updated_options']['main-design']);


                    var newTexture = "bodyMainTexture";

                    if(packageType === "glass-bottles"){
                        newTexture="bodyGBottleMainTexture";
                    }
                    if(packageType === "plastic-drink-cups"){
                        newTexture="bodyPlasticCupTexture";
                    }
                    if(packageType === "drink-cups"){
                        newTexture="bodyPlasticCupTexture";
                    }
                    THREEController.changeTexture(newTexture , args[0]['updated_action_values']['main-design'].value.url, masterProductUUID, versionProductUUID,setTextureInitCount);
                    countAllTex++;

                }


               if(defaultValueMainDesignUUID === args[0]['updated_options']['main-design']){
                    setIsMainDesignActive(false);
                } else {
                    setIsMainDesignActive(true);
                }
            }


            //METALLIC MAP
            if (event === 'update_options' && args[0]['updated_options']['metallic-design'] !== undefined ) {

                if (args[0]['updated_action_values'].length === 0) {


                    setBodyMetallicTextureUUID(args[0]['updated_options']['metallic-design']);
                    setMetallicTextureBody(getOptionURLFromUUID(args[0]['updated_options']['metallic-design']));

                    var newTexture= "bodyMetallicTexture";
                    if(packageType === "glass-bottles"){
                        newTexture="bodyGBottleMetallicTexture";
                    }
                    if(packageType === "plastic-drink-cups"){
                        newTexture="bodyPlasticCupMetallicTexture";
                    }

                    THREEController.changeTexture(newTexture, getOptionURLFromUUID(args[0]['updated_options']['metallic-design']), masterProductUUID, versionProductUUID,setTextureInitCount);
                    countAllTex++;

                } else {
                    var newAlphaDesignValues = [];
                    newAlphaDesignValues.push(alphaDesignValues[0]);
                    newAlphaDesignValues.push(args[0]['updated_action_values']['metallic-design'].value);

                    setMetallicDesignValues(newAlphaDesignValues);
                    setMetallicTextureBody(args[0]['updated_action_values']['metallic-design'].value.url);

                    setBodyMetallicTextureUUID(args[0]['updated_options']['metallic-design']);

                    var newTexture= "bodyMetallicTexture";
                    if(packageType === "glass-bottles"){
                        newTexture="bodyGBottleMetallicTexture";
                    }
                    if(packageType === "plastic-drink-cups"){
                        newTexture="bodyPlasticCupMetallicTexture";
                    }


                    THREEController.changeTexture(newTexture, args[0]['updated_action_values']['metallic-design'].value.url, masterProductUUID, versionProductUUID,setTextureInitCount);
                    countAllTex++;

                }
                if(defaultValueMetallicDesignUUID === args[0]['updated_options']['metallic-design']){
                    setIsMetallicDesignActive(false);
                } else {
                    setIsMetallicDesignActive(true);
                }

            }


            //ALPHA MAP
            if (event === 'update_options' && args[0]['updated_options']['alpha-design'] !== undefined ) {

                if (args[0]['updated_action_values'].length === 0) {


                    setBodyAlphaTextureUUID(args[0]['updated_options']['alpha-design']);
                    setAlphaTextureBody(getOptionURLFromUUID(args[0]['updated_options']['alpha-design']));


                    var newTexture= "bodyAlphaTexture";
                    if(packageType === "glass-bottles"){
                        newTexture="bodyGBottleAlphaTexture";
                    }
                    if(packageType === "plastic-drink-cups"){
                        newTexture="bodyPlasticCupAlphaTexture";
                    }
                    if(packageType === "drink-cups"){
                        newTexture="bodyPlasticCupAlphaTexture";
                    }

                    THREEController.changeTexture(newTexture, getOptionURLFromUUID(args[0]['updated_options']['alpha-design']), masterProductUUID, versionProductUUID,setTextureInitCount);
                    countAllTex++;



                } else {
                    var newAlphaDesignValues = [];
                    newAlphaDesignValues.push(alphaDesignValues[0]);
                    newAlphaDesignValues.push(args[0]['updated_action_values']['alpha-design'].value);

                    setAlphaDesignValues(newAlphaDesignValues);
                    setAlphaTextureBody(args[0]['updated_action_values']['alpha-design'].value.url);

                    setBodyAlphaTextureUUID(args[0]['updated_options']['alpha-design']);

                    var newTexture= "bodyAlphaTexture";
                    if(packageType === "glass-bottles"){
                        newTexture="bodyGBottleAlphaTexture";
                    }
                    if(packageType === "plastic-drink-cups"){
                        newTexture="bodyPlasticCupAlphaTexture";
                    }


                    THREEController.changeTexture(newTexture , args[0]['updated_action_values']['alpha-design'].value.url, masterProductUUID, versionProductUUID,setTextureInitCount);
                    countAllTex++;

                }
                if(defaultValueAlphaDesignUUID === args[0]['updated_options']['alpha-design']){
                    setIsAlphaDesignActive(false);
                } else {
                    setIsAlphaDesignActive(true);
                }
            }


            // body/color
            if (event === 'update_options' && args[0]['updated_options']['body-color'] !== undefined && args[0]['updated_options']['body-color'] !== null) {

                if(args[0]['updated_action_values']&& args[0]['updated_action_values']['body-color'] && args[0]['updated_action_values']['body-color']["value"]["name"]!== undefined){
                    if(args[0]['updated_action_values']['body-color']["value"]["name"] === "Custom"){


                        const hexBarva = args[0]['updated_action_values']['body-color']['value']['value'];

                        const vysledek = oddelitBarvuAAlfu(hexBarva);

                        THREEController.changeColorBody(vysledek.barva, vysledek.alfaCislo);
                        setBottleColor(args[0]['updated_action_values']['body-color']['value']['value']);
                        setBottleColorName(args[0]['updated_action_values']['body-color']["value"]["name"]);
                    }else {

                        const hexBarva = getOptionValueFromUUID(args[0]['updated_options']['body-color']);

                        const vysledek = oddelitBarvuAAlfu(hexBarva);

                        THREEController.changeColorBody(vysledek.barva, vysledek.alfaCislo);
                        setBodyColorUUID(args[0]['updated_options']['body-color']);
                        setBodyColor(getOptionValueFromUUID(args[0]['updated_options']['body-color']));
                        setBodyColorName(getOptionNameFromUUID(args[0]['updated_action_values']['body-color']["value"]["name"]));
                    }
                } else {
                    const hexBarva = getOptionValueFromUUID(args[0]['updated_options']['body-color']);

                    const vysledek = oddelitBarvuAAlfu(hexBarva);

                    THREEController.changeColorBody(vysledek.barva, vysledek.alfaCislo);
                    setBodyColorUUID(args[0]['updated_options']['body-color']);

                    setBodyColor(getOptionValueFromUUID(args[0]['updated_options']['body-color']));
                    setBodyColorName(getOptionNameFromUUID(args[0]['updated_options']['body-color']));
                }
                setBodyColorUUID(args[0]['updated_options']['body-color']);
                changeEditorColorsShow(false, 'body');
                setTimeout(function(){
                    THREEController.takeScreenshot(masterProductUUID, versionProductUUID,setLoadProductsShow, false, allComments,commentActive);
                }, 35);

            }
            // opening/color
            if (event === 'update_options' && args[0]['updated_options']['opening-color'] !== undefined && args[0]['updated_options']['opening-color'] !== null) {

                const hexBarva = getOptionValueFromUUID(args[0]['updated_options']['opening-color']);

                const vysledek = oddelitBarvuAAlfu(hexBarva);

                console.log("OPENING COOLOR ",getOptionValueFromUUID(args[0]['updated_options']['opening-color']) );
                THREEController.changeColorOpening(vysledek.barva, vysledek.alfaCislo);
                setOpeningColor(vysledek.barva);
                openingColorRef.current =vysledek.barva;
                setOpeningColorName(getOptionNameFromUUID(args[0]['updated_options']['opening-color']));

                setOpeningColorUUID(args[0]['updated_options']['opening-color']);

                openingColorUUIDRef.current = args[0]['updated_options']['opening-color'];

                setTimeout(function(){
                    THREEController.takeScreenshot(masterProductUUID, versionProductUUID,setLoadProductsShow, false, allComments,commentActive);
                }, 35);
                changeEditorColorsShow(false);

            }
            // shell/color
            if (event === 'update_options' && args[0]['updated_options']['shell-color'] !== undefined && args[0]['updated_options']['shell-color'] !== null) {

                if(args[0]['updated_action_values']&& args[0]['updated_action_values']['shell-color'] && args[0]['updated_action_values']['shell-color']["value"]["name"]!== undefined){
                        if(args[0]['updated_action_values']['shell-color']["value"]["name"] === "Custom"){



                            const hexBarva = args[0]['updated_action_values']['shell-color']['value']['value'];

                            const vysledek = oddelitBarvuAAlfu(hexBarva);

                            THREEController.changeColorShell(vysledek.barva, vysledek.alfaCislo);

                          //  THREEController.changeColorShell(args[0]['updated_action_values']['shell-color']['value']['value']);
                            setShellColor(args[0]['updated_action_values']['shell-color']['value']['value']);
                            setShellColorName(args[0]['updated_action_values']['shell-color']["value"]["name"]);
                        }else {

                            const hexBarva = getOptionValueFromUUID(args[0]['updated_options']['shell-color']);

                            const vysledek = oddelitBarvuAAlfu(hexBarva);

                            THREEController.changeColorShell(vysledek.barva, vysledek.alfaCislo);

                           // THREEController.changeColorShell(getOptionValueFromUUID(args[0]['updated_options']['shell-color']));
                            setShellColor(getOptionValueFromUUID(args[0]['updated_options']['shell-color']));
                            setShellColorName(getOptionNameFromUUID(args[0]['updated_action_values']['shell-color']["value"]["name"]));
                        }
                } else {
                    const hexBarva = getOptionValueFromUUID(args[0]['updated_options']['shell-color']);

                    const vysledek = oddelitBarvuAAlfu(hexBarva);

                    THREEController.changeColorShell(vysledek.barva, vysledek.alfaCislo);

                  //  THREEController.changeColorShell(getOptionValueFromUUID(args[0]['updated_options']['shell-color']));
                    setShellColor(getOptionValueFromUUID(args[0]['updated_options']['shell-color']));
                    setShellColorName(getOptionNameFromUUID(args[0]['updated_options']['shell-color']));
                }

                setShellColorUUID(args[0]['updated_options']['shell-color']);
                changeEditorColorsShow(false, 'shells');
                setTimeout(function(){
                    THREEController.takeScreenshot(masterProductUUID, versionProductUUID,setLoadProductsShow, false, allComments,commentActive);
                }, 35);

            }
            // tabs/color
            if (event === 'update_options' && args[0]['updated_options']['tabs-color'] !== undefined && args[0]['updated_options']['tabs-color'] !== null) {

                if(args[0]['updated_action_values']&& args[0]['updated_action_values']['tabs-color'] && args[0]['updated_action_values']['tabs-color']["value"]["name"]!== undefined){
                    if(args[0]['updated_action_values']['tabs-color']["value"]["name"] === "Custom"){

                        const hexBarva = args[0]['updated_action_values']['tabs-color']['value']['value'];

                        const vysledek = oddelitBarvuAAlfu(hexBarva);

                        THREEController.changeColorTab(vysledek.barva, vysledek.alfaCislo);

                     //   THREEController.changeColorTab(args[0]['updated_action_values']['tabs-color']['value']['value']);
                        setTabColor(args[0]['updated_action_values']['tabs-color']['value']['value']);
                        setTabColorName(args[0]['updated_action_values']['tabs-color']["value"]["name"]);
                    }else {



                        const hexBarva = getOptionValueFromUUID(args[0]['updated_options']['tabs-color']);

                        const vysledek = oddelitBarvuAAlfu(hexBarva);

                        THREEController.changeColorTab(vysledek.barva, vysledek.alfaCislo);

                     //   THREEController.changeColorTab(getOptionValueFromUUID(args[0]['updated_options']['tabs-color']));
                        setTabColor(getOptionValueFromUUID(args[0]['updated_options']['tabs-color']));
                        setTabColorName(getOptionNameFromUUID(args[0]['updated_action_values']['tabs-color']["value"]["name"]));
                    }
                } else {

                    const hexBarva = getOptionValueFromUUID(args[0]['updated_options']['tabs-color']);

                    const vysledek = oddelitBarvuAAlfu(hexBarva);

                    THREEController.changeColorTab(vysledek.barva, vysledek.alfaCislo);

                   // THREEController.changeColorTab(getOptionValueFromUUID(args[0]['updated_options']['tabs-color']));
                    setTabColor(getOptionValueFromUUID(args[0]['updated_options']['tabs-color']));
                    setTabColorName(getOptionNameFromUUID(args[0]['updated_options']['tabs-color']));
                }

                setTabColorUUID(args[0]['updated_options']['tabs-color']);
                changeEditorColorsShow(false, 'tabs');
                setTimeout(function(){
                    THREEController.takeScreenshot(masterProductUUID, versionProductUUID,setLoadProductsShow, false, allComments,commentActive);
                }, 35);

            }
            // fluid/color
            if (event === 'update_options' && args[0]['updated_options']['fluid-color'] !== undefined && args[0]['updated_options']['fluid-color'] !== null) {

                if(args[0]['updated_action_values']&& args[0]['updated_action_values']['fluid-color'] && args[0]['updated_action_values']['fluid-color']["value"]["name"]!== undefined){
                    if(args[0]['updated_action_values']['fluid-color']["value"]["name"] === "Custom"){

                        const hexBarva = args[0]['updated_action_values']['fluid-color']['value']['value'];

                        const vysledek = oddelitBarvuAAlfu(hexBarva);

                        THREEController.changeColorFluid(vysledek.barva, vysledek.alfaCislo);

                     //   THREEController.changeColorFluid(args[0]['updated_action_values']['fluid-color']['value']['value']);
                        setFluidColor(args[0]['updated_action_values']['fluid-color']['value']['value']);
                        setFluidColorName(args[0]['updated_action_values']['fluid-color']["value"]["name"]);
                    }else {

                        const hexBarva = getOptionValueFromUUID(args[0]['updated_options']['fluid-color']);

                        const vysledek = oddelitBarvuAAlfu(hexBarva);

                        THREEController.changeColorFluid(vysledek.barva, vysledek.alfaCislo);


                        /// THREEController.changeColorFluid(getOptionValueFromUUID(args[0]['updated_options']['fluid-color']));
                        setFluidColor(getOptionValueFromUUID(args[0]['updated_options']['fluid-color']));
                        setFluidColorName(getOptionNameFromUUID(args[0]['updated_action_values']['fluid-color']["value"]["name"]));
                    }
                } else {
                    const hexBarva = getOptionValueFromUUID(args[0]['updated_options']['fluid-color']);

                    const vysledek = oddelitBarvuAAlfu(hexBarva);

                    THREEController.changeColorFluid(vysledek.barva, vysledek.alfaCislo);


                    //THREEController.changeColorFluid(getOptionValueFromUUID(args[0]['updated_options']['fluid-color']));
                    setFluidColor(getOptionValueFromUUID(args[0]['updated_options']['fluid-color']));
                    setFluidColorName(getOptionNameFromUUID(args[0]['updated_options']['fluid-color']));
                }
                setFluidColorUUID(args[0]['updated_options']['fluid-color']);
                changeEditorColorsShow(false, 'fluids');
                setTimeout(function(){
                    THREEController.takeScreenshot(masterProductUUID, versionProductUUID,setLoadProductsShow, false, allComments,commentActive);
                }, 35);

            }

            // bottle/color
            if (event === 'update_options' && args[0]['updated_options']['bottle-color'] !== undefined && args[0]['updated_options']['bottle-color'] !== null) {

                if(args[0]['updated_action_values']&& args[0]['updated_action_values']['bottle-color'] && args[0]['updated_action_values']['bottle-color']["value"]["name"]!== undefined){
                    if(args[0]['updated_action_values']['bottle-color']["value"]["name"] === "Custom"){

                        const hexBarva = args[0]['updated_action_values']['bottle-color']['value']['value'];

                        const vysledek = oddelitBarvuAAlfu(hexBarva);

                        THREEController.changeColorBottle(vysledek.barva, vysledek.alfaCislo);


                      //  THREEController.changeColorBottle(args[0]['updated_action_values']['bottle-color']['value']['value']);
                        setBottleColor(args[0]['updated_action_values']['bottle-color']['value']['value']);
                        setBottleColorName(args[0]['updated_action_values']['bottle-color']["value"]["name"]);
                    }else {

                        const hexBarva = getOptionValueFromUUID(args[0]['updated_options']['bottle-color'])

                        const vysledek = oddelitBarvuAAlfu(hexBarva);

                        THREEController.changeColorBottle(vysledek.barva, vysledek.alfaCislo);



                      //  THREEController.changeColorBottle(getOptionValueFromUUID(args[0]['updated_options']['bottle-color']));
                        setBottleColor(getOptionValueFromUUID(args[0]['updated_options']['bottle-color']));
                        setBottleColorName(getOptionNameFromUUID(args[0]['updated_action_values']['bottle-color']["value"]["name"]));
                    }
                } else {
                    const hexBarva = getOptionValueFromUUID(args[0]['updated_options']['bottle-color'])

                    const vysledek = oddelitBarvuAAlfu(hexBarva);

                    THREEController.changeColorBottle(vysledek.barva, vysledek.alfaCislo);


                  //  THREEController.changeColorBottle(getOptionValueFromUUID(args[0]['updated_options']['bottle-color']));
                    setBottleColor(getOptionValueFromUUID(args[0]['updated_options']['bottle-color']));
                    setBottleColorName(getOptionNameFromUUID(args[0]['updated_options']['bottle-color']));
                }
                setBottleColorUUID(args[0]['updated_options']['bottle-color']);
                changeEditorColorsShow(false, 'bottles');
                setTimeout(function(){
                    THREEController.takeScreenshot(masterProductUUID, versionProductUUID,setLoadProductsShow, false, allComments,commentActive);
                }, 35);

            }

            if (event === 'update_options' && args[0]['updated_options']['matte-design'] !== undefined && args[0]['updated_options']['matte-design'] !== null) {
                THREEController.switchMatteMaterial(getOptionValueFromUUID(args[0]['updated_options']['matte-design']));
                setMatteDesign(getOptionValueFromUUID(args[0]['updated_options']['matte-design']));
                setMatteDesignUUID(args[0]['updated_options']['matte-design']);
                setTimeout(function(){
                    THREEController.takeScreenshot(masterProductUUID, versionProductUUID,setLoadProductsShow, false, allComments,commentActive);
                }, 35);

            }

            if (event === 'update_options' && args[0]['updated_action_values']['frontface-angle'] !== undefined && args[0]['updated_action_values']['frontface-angle'] !== null) {

                setAngleRotate(args[0]['updated_action_values']['frontface-angle']["value"]["value"]);

                THREEController.rotateProductDefault(args[0]['updated_action_values']['frontface-angle']["value"]["value"]);

            //    setAngleRotateOriginal(angleRotate);
                setTimeout(function(){
                    THREEController.takeScreenshot(masterProductUUID, versionProductUUID,setLoadProductsShow, false, allComments,commentActive);
                }, 35);

            }

            //
            var newIntervalX = setInterval(function(){

                if(countAllTex > 0){

                    if(neco >= countAllTex){
                        console.log("NECO fotime", neco, countAllTex);
                        neco=0;
                        setTimeout(function(){
                            THREEController.takeScreenshot(masterProductUUID, versionProductUUID,setLoadProductsShow, false, allComments,commentActive);
                        }, 100);

                        clearInterval(newIntervalX);
                    }
                }else{

                    clearInterval(newIntervalX);
                }


            }, 100);



            setTimeout(function(){
                THREEController.render();
            }, 100);


        });

        ///// comments
        socketComments = io(process.env.NEXT_PUBLIC_OBALERO_SOCKET_BASEPATH + 'comments/' + slugState, {
            transports: ['websocket'],
            auth: {
                token: userTeamState,
            },

        });

        socketComments.on('connect', () => {

        });
        socketComments.on('list_sanchez', () => {

        });
        socketComments.onAny((event, ...args) => {

            if(event === "create" || event === "update" || event === "delete" ){

                    loadComments(versionProductUUID,true, true);

            }

            setSocketInited(true);


        });
    };

       ///////////////// END SOCKETS

    useEffect(() => {
        if (masterProductUUID !== null && versionProductUUID !== null) {
            if (!plugin) {
                setUpMenuProductIDZ(versionProductUUID, masterProductUUID);
            }
        }
    }, [masterProductUUID, versionProductUUID]);
    ///////////////// END SOCKETS

    //////////////////////// USE EFFECTS

    /////////////1 Init three js
    useEffect(() => {
        if (!threeInited && packageType !== '') {

            THREEController.init(plugin, null, packageType, setFPSLowered);
            setThreeInited(true);
        }
    }, [packageType]);
    //////////// 2) Set tokens
    useEffect(() => {
        if (plugin) {

            setSlugState(pluginProductID);
            setOriginalSlugState(pluginProductID);
            setUserTeamState(getCookie('pluginLoginSessionTeamToken'));
            setUserTokenState(getCookie('pluginLoginSessionToken'));
            setLoadingProgressPercent(10);

        } else {
            setLoadingProgressPercent(10);
            setSlugState(slug);

            setUserTeamState(getCookie('userTeam'));
            setUserTokenState(session.accessToken);
        }
    }, []);



    useEffect(() => {
        if (plugin && pluginProductID) {
            setSlugState(pluginProductID);
        }
    }, [pluginProductID]);

    useEffect(() => {
        if (plugin && slugState && slugState !== originalSlugState && isShrink !== null) {
            setLoadProductsShow(true);

            setLoadingProgressPercent(0);
            setOpeningModel(null);
            setBodyModel(null);
            setOriginalSlugState(slugState);

            THREEController.init(plugin, loadEditorDataAPI, isShrink,setFPSLowered);


        }

    }, [slugState, originalSlugState, isShrink]);


    const popStateBack = (e) => {

        if(window.location.href.includes("&")){
            window.open(window.location.href, '_self');
        }

    }


    //////////// 3) Load Datas and prepare UI

    useEffect(() => {
        if (userTeamState !== null && userTeamState !== undefined && userTokenState !== null && slugState !== null) {
            setBackgroundColors(AppConfig.editor_backgrounds);

            loadEditorDataAPI();


            if (editorMode === 'comment') {
                THREEController.activateComments();
            } else {
                THREEController.removeDecals();
            }
        }
    }, [userTeamState, userTokenState, slugState]);

    //////////// 3) Load Models and textures / scenes

    const [allModelsLoaded, setAllModelsLoaded] = useState(false);
    const [openingsLoaded, setOpeningsLoaded] = useState(false);


    const [allTexturesAndOptionsLoaded, setAllTexturesAndOptionsLoaded] = useState(false);

    useEffect(() => {

        if (bodyModel !== null && openingModel !== null && !allModelsLoaded && threeInited) {
            if(window.innerWidth<991){
                changeActionMenu("default");
            }

            loadModels();
        }
    }, [bodyModel, openingModel, threeInited]);



    useEffect(() => {
        if (allModelsLoaded && !allTexturesAndOptionsLoaded && allEditorMenuActions.length > 0 && openingsLoaded) {

            loadTexturesAndSelectUserOptions();
        }
    }, [allModelsLoaded, userSelectedOptionsVar, allEditorMenuActions, openingsLoaded]);

    const [reloadTextures, setReloadTextures] = useState(false);
    useEffect(() => {
        if (reloadTextures) {
            setReloadTextures(false);
            loadTexturesAndSelectUserOptions();
        }
    }, [reloadTextures]);

    const [bodyMainTextureUUID, setBodyMainTextureUUID] = useState('');

    const [alphaMainTextureUUID, setBodyAlphaTextureUUID] = useState('');



    const [bodyMetallicTextureUUID, setBodyMetallicTextureUUID] = useState('');

    const [metallicTextureBody, setMetallicTextureBody] = useState('');


    const [shellColorUUID, setShellColorUUID] = useState('');
    const [shellColorName, setShellColorName] = useState('Default');


    const [bodyColorName, setBodyColorName] = useState('Default');
    const [bottleColorName, setBottleColorName] = useState('Default');
    const [fluidColorName, setFluidColorName] = useState('Default');
    const [tabColorName, setTabColorName] = useState('Default');

    const [openingColorName, setOpeningColorName] = useState('Default');

    const [openingColorUUID, setOpeningColorUUID] = useState('');
    const [bodyColorUUID, setBodyColorUUID] = useState('');



    const [packageOpeningUUID, setPackageOpeningUUID] = useState(null);
    const [packageOpeningName, setPackageOpeningName] = useState("");

    const [tabColorUUID, setTabColorUUID] = useState('');
    const [bottleColorUUID, setBottleColorUUID] = useState('');
    const [fluidColorUUID, setFluidColorUUID] = useState('');

    function oddelitBarvuAAlfu(hex) {
        // Odstraníme znak "#" (pokud existuje)
        const bezMrizky = hex.replace('#', '');

        // Pokud hex kód obsahuje 8 znaků (RRGGBBAA)
        if (bezMrizky.length === 8) {
            // Prvních 6 znaků je samotná barva
            const barva = `#${bezMrizky.substring(0, 6)}`;
            // Poslední 2 znaky představují alfa kanál v hex formátu
            const alfaHex = bezMrizky.substring(6);
            // Převod alfa kanálu na číslo od 0 do 1
            const alfaCislo = parseInt(alfaHex, 16) / 255;
            return { barva, alfaHex, alfaCislo };
        }

        // Pokud hex kód neobsahuje alfa, vrátíme původní barvu
        return { barva: hex, alfaHex: null, alfaCislo: null };
    }

    const [matteDesignUUID, setMatteDesignUUID] = useState('');

    const [matteDesign, setMatteDesign] = useState(false);
    const loadTexturesAndSelectUserOptions = () => {


        editorScenes.map((editorScene, indexEditorScene) => {
            if (selectedScene == editorScene.uuid) {
                THREEController.loadEnviroment(editorScene.value);
            }
        });

        setCurrentScene(selectedScene);

        var replace = userSelectedOptionsVar;

        var shellColor;
        var openingColor;
        var tabColor;
        var bottleColor;
        var bodyColor;
        var fluidColor;
        var mainBodyDesign;
        var alphaBodyDesign;
        var metallicBodyDesign;
        var matteDesign;

        var selectedScene = replace['scene'];

        if (!isShrink) {
            if (!('frontface-angle' in replace)) {


                setAngleRotate(getOptionValueFromUUID(getDefaultOptionValueFromKey('frontface-angle')));
                THREEController.rotateProductDefault(getOptionValueFromUUID(getDefaultOptionValueFromKey('frontface-angle')), packageType === 'shrinks' ? true : false);
            } else {

                setAngleRotate(getOptionValueFromUUID(replace['frontface-angle']));

                THREEController.rotateProductDefault(getOptionValueFromUUID(replace['frontface-angle']));
            }
        } else {
            if (!('frontface-angle-sides' in replace)) {

                setSideRotationChecked(getDefaultOptionValueFromKey('frontface-angle-sides'));
                 setAngleRotate(getOptionValueFromUUID(getDefaultOptionValueFromKey('frontface-angle-sides')));
                THREEController.rotateProductDefault(getOptionValueFromUUID(getDefaultOptionValueFromKey('frontface-angle-sides')), true);
                THREEController.rotateProductShrinkInsideDefault(productVersionInsideRotation);
            } else {

                setSideRotationChecked(replace['frontface-angle-sides']);
                setAngleRotate(getOptionValueFromUUID(replace['frontface-angle-sides']));

                THREEController.rotateProductDefault(getOptionValueFromUUID(replace['frontface-angle-sides']), true);

                THREEController.rotateProductShrinkInsideDefault(productVersionInsideRotation);
            }
        }

        if (!('main-design' in replace)) {
            setIsMainDesignActive(true);
            mainBodyDesign = getDefaultOptionValueFromKey('main-design');
        } else {
            setIsMainDesignActive(true);
            mainBodyDesign = replace['main-design'];
        }

        if (!('alpha-design' in replace)) {
            setIsAlphaDesignActive(true);
            alphaBodyDesign = getDefaultOptionValueFromKey('alpha-design');
        } else {
            setIsAlphaDesignActive(true);
            alphaBodyDesign = replace['alpha-design'];
        }

        if (!('metallic-design' in replace)) {
            setIsMetallicDesignActive(true);
            metallicBodyDesign = getDefaultOptionValueFromKey('metallic-design');
        } else {
            setIsMetallicDesignActive(true);
            metallicBodyDesign = replace['metallic-design'];
        }

        if (!('matte-design' in replace)) {
            matteDesign = getDefaultOptionValueFromKey('matte-design');
        } else {
            matteDesign = replace['matte-design'];
        }

        if (!('shell-color' in replace)) {
            shellColor = getDefaultOptionValueFromKey('shell-color');
        } else {
            shellColor = replace['shell-color'];
        }
        if (!('opening-color' in replace)) {
            openingColor = getDefaultOptionValueFromKey('opening-color');
        } else {
            openingColor = replace['opening-color'];
        }

        if (!('tabs-color' in replace)) {
            tabColor = getDefaultOptionValueFromKey('tabs-color');
        } else {
            tabColor = replace['tabs-color'];
        }
        if (!('bottle-color' in replace)) {
            bottleColor = getDefaultOptionValueFromKey('bottle-color');
        } else {
            bottleColor = replace['bottle-color'];
        }
        if (!('body-color' in replace)) {
            bodyColor = getDefaultOptionValueFromKey('body-color');
        } else {
            bodyColor = replace['body-color'];
        }
        if (!('fluid-color' in replace)) {
            fluidColor = getDefaultOptionValueFromKey('fluid-color');
        } else {
            fluidColor = replace['fluid-color'];
        }


        setLoadingProgressSentence('mixing');

        setLoadingProgressPercent(60);
        setTimeout(function () {

            if (getOptionValueFromUUID(openingColor) !== 'okeydeafult') {

                const hexBarva = getOptionValueFromUUID(openingColor);
                const vysledek = oddelitBarvuAAlfu(hexBarva);


                THREEController.changeColorOpening(vysledek.barva, vysledek.alfaCislo);
                setOpeningColor(vysledek.barva);
                openingColorRef.current =vysledek.barva;


                setOpeningColorName(getOptionNameFromUUID(openingColor))
                setOpeningColorUUID(openingColor);

                openingColorUUIDRef.current = openingColor;

            }
          //  console.log("BODY COLOR ", bodyColor,getOptionValueFromUUID(bodyColor) ,replace );
            if (getOptionValueFromUUID(bodyColor) !== 'okeydeafult') {

                const hexBarva = getOptionValueFromUUID(bodyColor);
                const vysledek = oddelitBarvuAAlfu(hexBarva);

                THREEController.changeColorBody(vysledek.barva, vysledek.alfaCislo);

                setBodyColor(vysledek.barva);
                setBodyColorName(getOptionNameFromUUID(bodyColor));
                setBodyColorUUID(bodyColor);
                changeEditorColorsShow(false, 'body');
            }
            if (getOptionValueFromUUID(shellColor) !== 'okeydeafult') {
                const hexBarva = getOptionValueFromUUID(shellColor);
                const vysledek = oddelitBarvuAAlfu(hexBarva);

                THREEController.changeColorShell(vysledek.barva, vysledek.alfaCislo);


            //    THREEController.changeColorShell(getOptionValueFromUUID(shellColor));
                setShellColor(getOptionValueFromUUID(shellColor));

                setShellColorUUID(shellColor);
                setShellColorName(getOptionNameFromUUID(shellColor));

                changeEditorColorsShow(false, 'shells');
            }
            if (getOptionValueFromUUID(tabColor) !== 'okeydeafult') {
                const hexBarva = getOptionValueFromUUID(tabColor);
                const vysledek = oddelitBarvuAAlfu(hexBarva);

                THREEController.changeColorTab(vysledek.barva, vysledek.alfaCislo);


               // THREEController.changeColorTab(getOptionValueFromUUID(tabColor));
                setTabColor(getOptionValueFromUUID(tabColor));
                setTabColorName(getOptionNameFromUUID(tabColor));
                setTabColorUUID(tabColor);
                changeEditorColorsShow(false, 'tabs');
            }
            if (getOptionValueFromUUID(bottleColor) !== 'okeydeafult') {
                const hexBarva = getOptionValueFromUUID(bottleColor);
                const vysledek = oddelitBarvuAAlfu(hexBarva);

                THREEController.changeColorBottle(vysledek.barva, vysledek.alfaCislo);


             //   THREEController.changeColorBottle(getOptionValueFromUUID(bottleColor));
                setBottleColor(getOptionValueFromUUID(bottleColor));
                setBottleColorName(getOptionNameFromUUID(bottleColor));
                setBottleColorUUID(bottleColor);
                changeEditorColorsShow(false, 'bottles');
            }

            if (getOptionValueFromUUID(fluidColor) !== 'okeydeafult') {
                const hexBarva = getOptionValueFromUUID(fluidColor);
                const vysledek = oddelitBarvuAAlfu(hexBarva);

                THREEController.changeColorFluid(vysledek.barva, vysledek.alfaCislo);


             //   THREEController.changeColorFluid(getOptionValueFromUUID(fluidColor));
                setFluidColor(getOptionValueFromUUID(fluidColor));
                setFluidColorName(getOptionNameFromUUID(fluidColor));
                setFluidColorUUID(fluidColor);
                changeEditorColorsShow(false, 'fluids');
            }

console.log("KAMO. ", getOptionURLFromUUID(mainBodyDesign));
            if (getOptionValueFromUUID(mainBodyDesign) !== 'okeydeafult') {

                var newTexture = "bodyMainTexture";

                if(packageType === "glass-bottles"){
                    newTexture="bodyGBottleMainTexture";
                }
                if(packageType === "plastic-drink-cups"){
                    newTexture="bodyPlasticCupTexture";
                }

                if(packageType === "drink-cups"){
                    newTexture="bodyPlasticCupTexture";
                }
                THREEController.changeTexture(newTexture, getOptionURLFromUUID(mainBodyDesign));

                setMainTextureBody(getOptionURLFromUUID(mainBodyDesign));

                setBodyMainTextureUUID(mainBodyDesign);
            }

            if (getOptionValueFromUUID(alphaBodyDesign) !== 'okeydeafult') {


                var newTexture= "bodyAlphaTexture";
                if(packageType === "glass-bottles"){
                    newTexture="bodyGBottleAlphaTexture";
                }
                if(packageType === "plastic-drink-cups"){
                    newTexture="bodyPlasticCupAlphaTexture";
                }
                if(packageType === "drink-cups"){
                    newTexture="bodyPlasticCupAlphaTexture";
                }

                THREEController.changeTexture( newTexture , getOptionURLFromUUID(alphaBodyDesign));

                setAlphaTextureBody(getOptionURLFromUUID(alphaBodyDesign));

                setBodyAlphaTextureUUID(alphaBodyDesign);
            }


            if (getOptionValueFromUUID(metallicBodyDesign) !== 'okeydeafult') {

                var newTexture= "bodyMetallicTexture";
                if(packageType === "glass-bottles"){
                    newTexture="bodyGBottleMetallicTexture";
                }
                if(packageType === "plastic-drink-cups"){
                    newTexture="bodyPlasticCupMetallicTexture";
                }


                THREEController.changeTexture( newTexture , getOptionURLFromUUID(metallicBodyDesign));

                setMetallicTextureBody(getOptionURLFromUUID(metallicBodyDesign));

                setBodyMetallicTextureUUID(metallicBodyDesign);

            }

            if (getOptionValueFromUUID(matteDesign) !== 'okeydeafult') {
                THREEController.switchMatteMaterial(getOptionValueFromUUID(matteDesign));
                setMatteDesign(getOptionValueFromUUID(matteDesign));
                setMatteDesignUUID(matteDesign);
            }

            setLoadingProgressPercent(90);

            setLoadingProgressSentence('finishing');

        }, 300);
    };

    useEffect(() => {
        if (allEditorMenuActions !== undefined && allEditorMenuActions.length > 0) {
            allEditorMenuActions.map((value, index) => {
                if (index === 0) {

                }
            });
            ReactTooltip.rebuild();

        }
    }, [allEditorMenuActions]);

    const [angleRotate, setAngleRotate] = useState(0);


    useEffect(() => {
        if(session){
            if( getCookie('usrA') === undefined || getCookie('usrA') === null  || getCookie('usrA') === "" ){
                window.open('/terms-and-conditions',  "_self");
            } else {
            }
        }
    }, []);

    const [angleRotateOriginal, setAngleRotateOriginal] = useState(0);

    const handleChangeAngle = function (e: React.FormEvent<HTMLInputElement>) {

            THREEController.rotateProductDefault(e.currentTarget.value, packageType === 'shrinks' ? true : false);



        setAngleRotate(e.currentTarget.value);
    };

    const [packshotsList, setPackshotsList] = useState([]);


    const [renderScenes, setRenderScenes] = useState([]);


    const [selectedSceneCheckbox, handleOnChangeSceneCheckBox] = useState(null);
    const [selectedSceneVersionCheckbox, handleOnChangeSceneVersionCheckBox] = useState(null);

    const handleSceneUUID = (sceneUUID, sceneVersionUUID) => {
        handleOnChangeSceneCheckBox(sceneUUID);
        handleOnChangeSceneVersionCheckBox(sceneVersionUUID);
    };


    useEffect(() => {
        if (currentPackageUUID !== null) {
         //   loadRenderScenes();
            loadRenderViews();
        }
    }, [currentPackageUUID]);

    const downloadSketch = () => {

        fetch(process.env.NEXT_PUBLIC_OBALERO_API_BASEPATH + 'products/' + masterProductUUID + '/versions/' + versionProductUUID + '/sketch?format=illustrator', {
            method: 'GET',
            headers: {
                'Content-type': 'application/json',
                Authorization: 'Bearer ' + userTeamState, // notice the Bearer before your token
            },
        })
            .then(response => response.json())
            .then(function (data) {
                if (data.message !== undefined) {
                    Sentry.captureException('products/' + masterProductUUID + '/versions/' + versionProductUUID + '/sketch' + data.message + ' : ' + getCookie('userMail'));
                } else {

                    if (data.url !== null) {

                        const a = document.createElement('a');
                        a.style.display = 'none';
                        a.href = data.url;

                        document.body.appendChild(a);
                        a.click();
                        window.URL.revokeObjectURL(data.url);
                    } else {
                        setWrongEditorMessage('Template Missing!');
                        handleClickEditorMessage2();
                    }
                }

                setInitTextures(true);
            });
    };


    const [pricingLow, setPricingLow] = useState(0);
    const [pricingMedium, setPricingMedium] = useState(0);
    const [pricingHigh, setPricingHigh] = useState(0);

    const loadRenderViews = () => {
     //   setPackshotsList

        //         masterProductUUID
        // versionProductUUID
        //
        setLoadRendersShow(true);

        fetch(process.env.NEXT_PUBLIC_OBALERO_API_BASEPATH + 'render-scenes/' + slug, {
            method: 'GET',
            headers: {
                'Content-type': 'application/json',
                Authorization: 'Bearer ' + getCookie('userTeam'), // notice the Bearer before your token
            },
        })
            .then(response => response.json())
            .then(function (data) {
                if (data.message !== undefined) {
                    Sentry.captureException('render-scenes/' + slug + ': ' + data.message + ' : ' + getCookie('userMail'));
                }

                setRenderScenes(data);
                setLoadRendersShow(false);
                if (data.length > 0) {
                    handleOnChangeSceneCheckBox(data[0]['uuid']);

                if(data.length > 0){
                    setPackshotsList(data[0].views);

                    setPricingLow(data[0].pricing.low);
                    setPricingMedium(data[0].pricing.medium);
                    setPricingHigh(data[0].pricing.high);

                    setRenderScenes(data);
                }
                }


            });
    };

    const [setRotationActive, setSetRotationActive] = useState(false);
    const [initTextures, setInitTextures] = useState(true);
    const [sideRotationChecked, setSideRotationChecked] = useState(null);
    const [commentCanvasShow, setCommentCanvasShow] = useState(false);

    const getBrowserLocale = () => {
        try {
            return window.navigator.language.split('-')[0].toLowerCase();
        } catch {
            return 'en';
        }
    };
    const [isCzech, setIsCzech] = useState(getBrowserLocale() === 'cs' ? true  : false);

    const setRotationModeCans = state => {

        THREEController.setRotationMode(state, setAngleRotate, setProductVersionInsideRotation, productVersionInsideRotation);

        setSetRotationActive(state);

        if (state) {
            setRotationCanvasShow(true);
            setAngleRotateOriginal(angleRotate);
            setUpShrinkProductRotationCtrl('1');
        } else {
            setRotationCanvasShow(false);
        }
    };

    const setRotationMode = state => {

        THREEController.setRotationMode(state, setAngleRotate);

        setSetRotationActive(state);

        if (state) {
            setRotationCanvasShow(true);
            setAngleRotateOriginal(angleRotate);
        } else {
            setRotationCanvasShow(false);
        }


    };
    const cancelRotationMode = () => {

        THREEController.setRotationMode(false, setAngleRotate);
        setRotationCanvasShow(false);
        setSetRotationActive(false);

        setTimeout(function(){
            THREEController.rotateProductDefault(angleRotateOriginal, packageType === 'shrinks' ? true : false);
            setAngleRotate(angleRotateOriginal);
        },200);

    };

    const [frontFaceRotationOpened, setFrontFaceRotationOpened] = useState(false);

    const [designPopupOpened, setDesignPopupOpened] = useState(false);
    const [metalnessPopupOpened, setMetalnessPopupOpened] = useState(false);

    const [alphaPopupOpened, setAlphaPopupOpened] = useState(false);

    const [isMainDesignActive, setIsMainDesignActive] = useState(false);
    const [isMetallicDesignActive, setIsMetallicDesignActive] = useState(false);
    const [isAlphaDesignActive, setIsAlphaDesignActive] = useState(false);





    const ref = useRef(null);

    const ref2 = useRef(null);

    const ref3 = useRef(null);
    const ref4 = useRef(null);

    useEffect(() => {
        const handleOutSideClick = event => {

            if (!ref.current?.contains(event.target)) {

                setDesignPopupOpened(false);

            }
            if (!ref2.current?.contains(event.target)) {

                setMetalnessPopupOpened(false);
            }
            if (!ref3.current?.contains(event.target)) {
                setFrontFaceRotationOpened(false);
            }
            if (!ref4.current?.contains(event.target)) {
                setAlphaPopupOpened(false);
            }
        };

        window.addEventListener('mousedown', handleOutSideClick);

        return () => {
            window.removeEventListener('mousedown', handleOutSideClick);

            if (socket) {

                socket.close();
                socket.disconnect();
                socket.emit('end');
                socket.offAny();
                socket.removeAllListeners();
                socket = null;
            }
            if (socketEditor) {

                socketEditor.close();
                socketEditor.disconnect();
                socketEditor.emit('end');
                socketEditor.offAny();
                socketEditor.removeAllListeners();
                socketEditor = null;
            }

            if (socketComments ) {

                socketComments.close();
                socketComments.disconnect();
                socketComments.emit('end');
                socketComments.offAny();
                socketComments.removeAllListeners();
                socketComments = null;
            }

        };
    }, [ref]);

    const toggleReinitRendererInside = useCallback((): void => {
        THREEController.clearSceneFull();
    }, []);
    useEffect(() => {
        toggleReinitRenderer && toggleReinitRenderer(toggleReinitRendererInside);
    }, [toggleReinitRenderer, toggleReinitRendererInside]);


    const toggleWindowResizeInside = useCallback((): void => {

        var newInterval = setInterval(function(){
            THREEController.onWindowResize();

            setTimeout(function(){
              clearInterval(newInterval);
            }, 230);

        }, 10);

    }, []);
    useEffect(() => {
        toggleWindowResize && toggleWindowResize(toggleWindowResizeInside);
    }, [toggleWindowResize, toggleWindowResizeInside]);


    useEffect(() => {
        const exitingFunction = () => {

            THREEController.clearSceneFull();
        };

        router.events.on('routeChangeStart', exitingFunction);

        return () => {

            router.events.off('routeChangeStart', exitingFunction);
        };
    }, []);



    useEffect(() => {
        addEventListener("popstate", popStateBack);
        return () => {
            window.removeEventListener('popstate', popStateBack);
        };

    }, []);





    const [color, setColor] = useState('#123123');


    const [tabColorState, setTabColor] = useState('#123123');
    const [shellColorState, setShellColor] = useState('#123135');
    const [bottleColorState, setBottleColor] = useState('#123123');
    const [bodyColorState, setBodyColor] = useState('#123123');
    const [fluidColorState, setFluidColor] = useState('#123123');


    const [templateHeight, setTemplateHeight] = useState(null);
    const [templateWidth, setTemplateWidth] = useState(null);



    const setColorMouseUp = (event, key) => {

        setColor(color);


        updateOptionAPI(key,color);

    };

    const [productVersionInsideRotation, setProductVersionInsideRotation] = useState({
        '1': 20,
        '2': 40.5,
    });

    const setUpShrinkProductRotationCtrl = shrinkNumber => {
        var sideRotaion = null;
        if (sideARotation && sideRotationChecked === sideARotation.uuid) {
            sideRotaion = 'SideA';
        }
        if (sideBRotation && sideRotationChecked === sideBRotation.uuid) {
            sideRotaion = 'SideB';
        }
        THREEController.setUpShrinkProductRotation(shrinkNumber, shrinkType, sideRotaion);
    };

    const closeModalOutsideClickColors = (e) => {
        if( e.target.getAttribute("data-closemodalcolors") === "true"){
           changeEditorColorsShow(false, null);
        }
    }


    let handleClickNewComment = () => {

    };

    const finishComments = (versionUUID, newNumber,fullComment,replyNumber) => {


        if(fullComment && !replyNumber){

            if(commentsFilterType === 'all'){
                var newArrayX = allCommentsOriginal;
                newArrayX.push( fullComment.data);

                setAllComments(newArrayX);
                setCommentsFilterType("all");

                THREEController.removeDecals();
                newArrayX.map(comment => {
                    THREEController.makeCommentOnPack(comment.position,setCurrentNewCommentCount,comment.number, getCommentColorByStatus(comment.status.status) );
                });


            } else {

                var newArrayX = allCommentsOriginal;
                newArrayX.push( fullComment.data);

                var newArray=[];
                setCommentsFilterType("unresolved");
                newArrayX.map(comment => {

                    if(comment.status.status === "open" || comment.status.status === "new"){
                        newArray.push(comment);
                    }
                });

                setAllComments(newArray);
                THREEController.removeDecals();
                newArray.map(comment => {

                    THREEController.makeCommentOnPack(comment.position,setCurrentNewCommentCount,comment.number, getCommentColorByStatus(comment.status.status) );
                });


            }
            setActiveCommentFc(fullComment.data.number);
        }
        if(replyNumber){
            var newComments = [];

            allComments.map(comment => {

                if(comment.number === replyNumber){
                    comment.comments.push(fullComment.data);

                }

                newComments.push(comment);
            });

            setAllComments(newComments);

        }


        loadComments(versionUUID, true, false, newNumber);
        setNewComment(null);
        setNewCommentPosition(null);

    };
    const cancelAddComment = () => {

        THREEController.removeCommentPack((allComments.length));
        setNewComment(false);


    };

    useEffect(() => {
        if (openingModelName !== null && currentPackageUUID !== null && packageOpenings.length === 0 && threeInited && allModelsLoaded) {
            loadPackageOpenings(currentPackageUUID);
        }
    }, [openingModelName, currentPackageUUID, packageOpenings, threeInited,  allModelsLoaded]);


    let showSupport = () => {

        window.Intercom("show");
    };


    const [packshotDetailUUID, setPackshotDetailUUID] = useState(null);
    const [packshotDetailOpened, setPackshotDetailOpened] = useState(false);

    const [packshotDetailName, setPackshotDetailName] = useState(null);
    const [packshotDetailDescription, setPackshotDetailDescription] = useState(null);
    const [packshotDetailThumbnail, setPackshotDetailThumbnail] = useState(null);


    const [renderSceneViewOpenedUUID, setRenderSceneViewOpenedUUID] = useState(null);


    const [loadRendersShow, setLoadRendersShowVariable] = useState(false);
    const [loadTransitionRendersShow, setLoadTransitionRendersShow] = useState(false);

    var [lowQualityStatus, setLowQualityStatus] = useState(null);
    var [mediumQualityStatus, setMediumQualityStatus] = useState(null);
    var [highQualityStatus, setHighQualityStatus] = useState(null);

    const closePackshotOpened = () => {
        loadRenderViews();
        setPackshotDetailOpened(false);
    };


    const setLoadRendersShow = (variable) => {
        if(variable === true){
            setLoadRendersShowVariable(variable);
            setLoadTransitionRendersShow(true);
        } else{
            setTimeout(function() {
                setLoadTransitionRendersShow(false);
                setTimeout(function() {
                    setLoadRendersShowVariable(variable);
                },500);
            },300);
        }

    };


    const choosePackshotDetail = (uuid) => {
        setLowQualityRendering(false);
        setMediumQualityRendering(false);
        setHighQualityRendering(false);

        setLowPackshotUrl(null);
        setMediumPackshotUrl(null);
        setHighPackshotUrl(null);

        setRenderSceneViewOpenedUUID(uuid);
        setLoadRendersShow(true);

        fetch(process.env.NEXT_PUBLIC_OBALERO_API_BASEPATH + 'renders/' + versionProductUUID + '/render-scene-view/'+uuid, {
            method: 'GET',
            headers: {
                'Content-type': 'application/json',
                Authorization: 'Bearer ' + userTeamState,
            },
        })
            .then(response => response.json())
            .then(function (data) {

                if (data.message !== undefined) {
                    Sentry.captureException( 'renders/' + versionProductUUID + '/render-scene-view/'+uuid + ': ' + data.message + ' : ' + getCookie('userMail'));
                }
                setLoadRendersShow(false);


                if(data.low.status){
                    setLowQualityStatus(data.low.status);
                }
                if(data.medium.status){
                    setMediumQualityStatus(data.medium.status);
                }
                if(data.high.status){
                    setHighQualityStatus(data.high.status);
                }

                if(data.low.status && data.low.status !== "completed"){
                    setLowQualityRendering(true);
                }
                if(data.medium.status && data.medium.status !== "completed"){
                    setMediumQualityRendering(true);
                }
                if(data.high.status && data.high.status !== "completed"){
                    setHighQualityRendering(true);
                }

                if(data.low.status && data.low.status === "completed"){
                    setLowPackshotUrl(data.low.download_path);
                }
                if(data.medium.status && data.medium.status === "completed"){
                    setMediumPackshotUrl(data.medium.download_path);
                }
                if(data.high.status && data.high.status === "completed"){
                    setHighPackshotUrl(data.high.download_path);
                }

                setEstimatedTimeRenderLow(data.low.approximate_time);
                setEstimatedTimeRenderMid(data.medium.approximate_time);
                setEstimatedTimeRenderHigh(data.high.approximate_time);
                setPackshotDetailThumbnail(data.thumbnail ? data.thumbnail : null);

            });


       packshotsList.map((value, index) => {
                if(value.uuid === uuid){
                    setPackshotDetailName(value.name);
                    setPackshotDetailDescription(value.description);
                }
        });




        setPackshotDetailUUID(uuid);
        setPackshotDetailOpened(true);
        window.scrollTo({ top: 0, left: 0 });
    };

    const closeRenderShow = () => {
        setPackshotDetailOpened(false);
        changeRenderShow(false);
    };


    return (
        <>
            <Head>
                <title>
                    {productName} | Version {productVersionName}
                </title>

                <meta name="description" content="OBALERO - your best packaging friend." />
                <meta name="keywords" content="OBALERO, Packaging, Packshot design" />
                <meta property="og:title" content="OBALERO" />
                <meta property="og:description" content="OBALERO - your best packaging friend." />
                <meta property="og:site_name" content="OBALERO" />

            </Head>

            {fpsLoweredState ?
                <Link className="performance" href={"https://www.obalero.com/faq"}> <span style={{    textDecoration:"underline", position: "absolute", top: "30px", right: "30px",  zIndex: "99", fontSize:"18px"}}>
                        <FormattedMessage {...messages.performance_message}></FormattedMessage></span></Link>
                : null
            }

            {!plugin ? (
                <>

                        <>
                            <EditorSetFrontFaceRotationTop className={` ${commentCanvasShow ? 'active' : ''}`}>
                                <h1>     <FormattedMessage {...messages.editor_comments_new}></FormattedMessage> </h1>

                            </EditorSetFrontFaceRotationTop>

                            <EditorSetFrontFaceRotationBottom className={` ${commentCanvasShow ? 'active' : ''}`}>
                                <GlobalButtonFinal className={'borderLightGray cancel btn-circle'} style={{ left: "50%", transform: "translateX(-50%)", color: 'white', position: 'absolute' }} onClick={() => activateCommentsNew(false)}>
                                    <FormattedMessage {...messages.editor_button_cancel}></FormattedMessage>
                                </GlobalButtonFinal>


                            </EditorSetFrontFaceRotationBottom>


                            <RotationCanvas id={'rotationCanvas'} className={rotationCanvasShow ? 'show' : ''}></RotationCanvas>

                            <EditorLeftActionsBarWrapper className={` ${!setRotationActive ? 'active' : ''}`}
                                                         data-closemodalmenu={true}>



                                {editorMode !== "comment" ?
                                        <EditorLeftActionsBarWrapper className={` ${!setRotationActive ? 'active' : ''}`}
                                                                 data-closemodalmenu={true}>
                                        <EditorLeftActionsBarMinimal
                                            data-closemodalmenu={true}
                                            className={`actionsBar ${editorMode === 'edit' ? 'active' : ''} ${versionIsLocked ? 'versionIsLocked' : ''} ${actionsActive ? 'opened' : ''} `}>
                                            <button onClick={() => changeActionMenu('full')} className={`mainActionButton ${actionMenu != 'full' ? '' : 'active'} opening`}>
                                                <FontAwesomeIcon icon={faPenToSquare} />
                                            </button>
                                        </EditorLeftActionsBarMinimal>
                                        </EditorLeftActionsBarWrapper>
                                : null}
                                {editorMode === 'edit' ?

                                                        <EditorLeftActionsBarWindow
                                                            className={`leftWindowPopup cubePopup 
                                            ${versionIsLocked ? 'versionIsLocked' : ''} 
                                            ${actionsActive && editorMode === 'edit' ? '' : ''}
                                            ${actionsOptionsOpenedName === 'body' ? 'bodyOptions' : ''}
                                           ${actionsOptionsOpenedName === 'shell' ? 'shellOptions' : ''}
                                             ${actionsOptionsOpenedName === 'tab' ? 'tabOptions' : ''}
                                              ${!initTextures ? 'initTextures' : 'noInit'}
                                                 ${authData.userLanguage === "cs" ? 'isCzech' : ''}
                                               ${!initTextures && packageType === 'shrinks' ? 'withShrinkInit' : ''}
                                                      ${!initTextures && packageType === 'plastic-drink-cups' ? 'withPlasticDrinkCupsInit' : ''}
                                                           ${initTextures && packageType === 'plastic-drink-cups' ? 'withPlasticDrinkCups' : ''}
                                           ${initTextures && packageType === 'shrinks' ? 'withShrink' : ''}
                                    ${!initTextures && packageType === 'glass-bottles' ? 'withGBottlesInit' : ''}
                                           ${initTextures && packageType === 'glass-bottles' ? 'withGBottles' : ''}
                        
                                           ${!initTextures && packageType === 'cartons' ? 'withCartonInit' : ''}
                                           ${initTextures && packageType === 'cartons' ? 'withCarton' : ''}
                                             ${!initTextures && packageDescription === "SPFRUKO 500ml Kapalina"  ? 'withGBottlesInitKapalina' : ''}
                                             ${actionMenu == 'full' ? 'active' : ''}
                                                     ${actionMenu === 'opening' ? 'openingOptions' : ''}
                                                     ${packageType == 'cans' && actionMenu === 'opening' ? 'cansOptions' : ''}`}


                                                            data-closemodalmenu={true}
                                                            data-intercom-target="editorLeftControl"
                                                            id={"editorLeftControl"}
                                                        >
                                                            <div className={'holderLeftEdit'}
                                                                 data-closemodalmenu={true}
                                                            >
                                                                <div className={'header'} style={{ paddingBottom: '10px' }}>
                                                                    {actionsOptionsOpenedName === 'body' ? <img src={'/images/editor/body.svg'} /> : null}

                                                                    <button className={'closeButton'} onClick={() => changeActionMenu('default')}>


                                                                        <svg xmlns="http://www.w3.org/2000/svg"
                                                                             viewBox="0 0 384 512">
                                                                            <path
                                                                                d="M324.5 411.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L214.6 256 347.1 123.5c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L192 233.4 59.5 100.9c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L169.4 256 36.9 388.5c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L192 278.6 324.5 411.1z" />
                                                                        </svg>

                                                                    </button>
                                                                </div>

                                                                <div style={{ paddingTop: '5px', display: 'grid' }}></div>

                                                                <div className={`openingOptions optionsBox  ${actionMenu == 'full' ? 'active' : ''}`}>
                                                                    {canDoShellColor || canDoTabsColor ? (
                                                                        <div style={{
                                                                            paddingTop: '5px',
                                                                            display: 'grid',
                                                                        }}>
                                                                            <h5 style={{ marginTop: '0px' }}
                                                                                className={'designHeadline'}>
                                                                                <FormattedMessage {...messages.editor_edit_window_top_title}></FormattedMessage>
                                                                            </h5>

                                                                            <div
                                                                                className={'optionsButtons colorsButtons'}
                                                                                data-intercom-target="editorLeftControlColors"
                                                                                id={'editorLeftControlColors'}
                                                                            >
                                                                                {canDoShellColor ?
                                                                                    <>
                                                                                        <span><FormattedMessage {...messages.editor_edit_window_top_shell_color_title}></FormattedMessage>:</span>
                                                                                        <ul className={'colorsList'}>
                                                                                            <li>
                                                                                                <button
                                                                                                    data-actionuuid={''}
                                                                                                    data-actionkey={'tabs-color'}
                                                                                                    data-actionvalue={'fffxxx'}
                                                                                                    data-offset="{'right': 10}"
                                                                                                    data-tip={'Silver'}
                                                                                                    data-place="bottom"
                                                                                                    data-delay-show="1000"
                                                                                                    style={{ background: shellColorState }}
                                                                                                    onClick={() => changeEditorColorsShow(true, 'shells')}
                                                                                                ></button>
                                                                                                <span>{shellColorName}</span>

                                                                                            </li>
                                                                                        </ul>
                                                                                    </>
                                                                               : null }

                                                                                {canDoTabsColor ?

                                                                                    <>
                                                                                        <span> <FormattedMessage {...messages.editor_edit_window_top_tab_color_title}></FormattedMessage> :</span>

                                                                                        <ul className={'colorsList'}>
                                                                                            <li>
                                                                                                <button
                                                                                                    data-actionuuid={''}
                                                                                                    data-actionkey={'tabs-color'}
                                                                                                    data-actionvalue={'fffxxx'}
                                                                                                    data-offset="{'right': 10}"
                                                                                                    data-tip={'Silver'}
                                                                                                    data-place="bottom"
                                                                                                    data-delay-show="1000"
                                                                                                    style={{ background: tabColorState }}
                                                                                                    onClick={() => changeEditorColorsShow(true, 'tabs')}
                                                                                                >
                                                                                                </button>
                                                                                                <span>{tabColorName}</span>
                                                                                            </li>
                                                                                        </ul>

                                                                                    </>
                                                                            : null    }

                                                                            </div>
                                                                            <div
                                                                                style={{ borderBottom: '1px solid lightgray' }}></div>
                                                                        </div>
                                                                    ) : null}

                                                                    {canDoOpeningType ? (
                                                                        <div style={{
                                                                            paddingTop: '5px',
                                                                            display: 'grid',
                                                                        }}>
                                                                            <h5 style={{ marginTop: '10px' }}
                                                                                className={'designHeadline'}>
                                                                                <FormattedMessage {...messages.editor_edit_window_opening_title}></FormattedMessage>
                                                                            </h5>

                                                                            <div
                                                                                className={'optionsButtons colorsButtons'}>
                                                                                <span>   <FormattedMessage {...messages.editor_edit_window_opening_type_title}></FormattedMessage> </span>
                                                                                <ul className={'openingTypeList'}>
                                                                                    {packageOpenings !== null && packageOpenings.length > 0 ? (
                                                                                        <li onClick={() => changeEditorPackageOpeningsShow(true, 'tabs')}>
                                                                                            {packageOpenings.map(openingItem => {
                                                                                                if (packageOpeningUUID === openingItem.uuid) {
                                                                                                    return (
                                                                                                        <div>
                                                                                                            <img
                                                                                                                style={openingItem.thumbnail.fallback ? { } : {filter:"invert(1)"}}
                                                                                                                src={openingItem.thumbnail.fallback ? openingItem.thumbnail.fallback : "/images/logoMobile.svg"} />
                                                                                                            <span>{openingItem.name}</span>
                                                                                                        </div>
                                                                                                    );
                                                                                                }
                                                                                            })}
                                                                                        </li>
                                                                                    ) : null}
                                                                                </ul>
                                                                                {/*{packageOpeningName}*/}
                                                                                {/*{canDoOpeningColor.toString()}*/}
                                                                                {canDoOpeningColor && packageOpeningName !== "No opening" ?

                                                                                    <>
                                                                                        <span> <FormattedMessage {...messages.editor_edit_window_opening_color_title}></FormattedMessage>:</span>

                                                                                        <ul className={'colorsList'}>
                                                                                            <li>
                                                                                                <button
                                                                                                    data-actionuuid={''}
                                                                                                    data-actionkey={'opening-color'}
                                                                                                    data-actionvalue={'fffxxx'}
                                                                                                    data-offset="{'right': 10}"
                                                                                                    data-tip={'Silver'}
                                                                                                    data-place="bottom"
                                                                                                    data-delay-show="1000"
                                                                                                    style={{ background: openingColorState }}
                                                                                                    onClick={() => changeEditorColorsShow(true, 'opening')}
                                                                                                >
                                                                                                </button>
                                                                                                <span>{openingColorName}</span>
                                                                                            </li>
                                                                                        </ul>
                                                                                    </> : null}

                                                                            </div>
                                                                            <div
                                                                                style={{ borderBottom: '1px solid lightgray' }}></div>
                                                                        </div>
                                                                    ) : null}


                                                                    {packageType !== 'neo' ? (
                                                                        <div>
                                                                            <div style={{ paddingBottom: '15px' }}>
                                                                                <h5 className={'designHeadline'}>
                                                                                    <FormattedMessage {...messages.editor_edit_window_body_title}></FormattedMessage>
                                                                                </h5>

                                                                                <div className={'optionsButtons'}></div>

                                                                                {canDoBottleColor ?
                                                                                    <>

                                                                                        <span> <FormattedMessage {...messages.editor_edit_window_bottle_color_title}></FormattedMessage>:</span>

                                                                                        <ul className={'colorsList'}>
                                                                                            <li>
                                                                                                <button
                                                                                                    data-actionuuid={''}
                                                                                                    data-actionkey={'bottle-color'}
                                                                                                 data-actionvalue={'fffxxx'}
                                                                                                 data-offset="{'right': 10}"
                                                                                                 data-tip={'Silver'}
                                                                                                 data-place="bottom"
                                                                                                 data-delay-show="1000"
                                                                                                 style={{ background: bottleColorState }}
                                                                                                 onClick={() => changeEditorColorsShow(true, 'bottles')}
                                                                                             >
                                                                                             </button>
                                                                                             <span>{bottleColorName} </span>
                                                                                         </li>
                                                                                     </ul>
                                                                                     <div
                                                                                         style={{ borderBottom: '1px solid lightgray' }}></div>
                                                                                 </>

                                                                                 : null}

                                                                                {canDoBodyColor ?
                                                                                    <>

                                                                                        <span> <FormattedMessage {...messages.editor_edit_window_body_color_title}></FormattedMessage>:</span>

                                                                                        <ul className={'colorsList'}>
                                                                                            <li>
                                                                                                <button
                                                                                                    data-actionuuid={''}
                                                                                                    data-actionkey={'body-color'}
                                                                                                    data-actionvalue={'fffxxx'}
                                                                                                    data-offset="{'right': 10}"
                                                                                                    data-tip={'Silver'}
                                                                                                    data-place="bottom"
                                                                                                    data-delay-show="1000"
                                                                                                    style={{ background: bodyColorState }}
                                                                                                    onClick={() => changeEditorColorsShow(true, 'body')}
                                                                                                >
                                                                                                </button>
                                                                                                <span>{bodyColorName} </span>
                                                                                            </li>
                                                                                        </ul>
                                                                                        <div
                                                                                            style={{ borderBottom: '1px solid lightgray' }}></div>
                                                                                    </>

                                                                                    : null}

                                                                                {canDoFluidColor ?
                                                                                    <>

                                                                                        <span> <FormattedMessage {...messages.editor_edit_window_fluid_color_title}></FormattedMessage>:</span>

                                                                                        <ul className={'colorsList'}>
                                                                                            <li>
                                                                                                <button
                                                                                                    data-actionuuid={''}
                                                                                                    data-actionkey={'fluid-color'}
                                                                                                    data-actionvalue={'fffxxx'}
                                                                                                    data-offset="{'right': 10}"
                                                                                                    data-tip={'Silver'}
                                                                                                    data-place="bottom"
                                                                                                    data-delay-show="1000"
                                                                                                    style={{ background: fluidColorState }}
                                                                                                    onClick={() => changeEditorColorsShow(true, 'fluids')}
                                                                                                >
                                                                                                </button>
                                                                                                <span>{fluidColorName} </span>
                                                                                            </li>
                                                                                        </ul>
                                                                                        <div
                                                                                            style={{ borderBottom: '1px solid lightgray' }}></div>
                                                                                    </>

                                                                                    : null}

                                                                                {canDoMatte  ? (
                                                                                    <div id={"varnish_box"}
                                                                                         data-intercom-target="varnish_box"
                                                                                    >
                                                                                <span>
                                                                                    <FormattedMessage {...messages.editor_edit_window_body_varnish}></FormattedMessage>:{' '}
                                                                                    <input
                                                                                        type="radio"
                                                                                        checked={matteDesign ? false : true}
                                                                                        onChange={() => switchMatteDesignFun(true)}
                                                                                    />{' '}
                                                                                    <FormattedMessage {...messages.editor_edit_window_body_varnish_glossy}></FormattedMessage>{' '}
                                                                                    <input
                                                                                        type="radio"
                                                                                        checked={matteDesign ? true : false}
                                                                                        onChange={() => switchMatteDesignFun(false)}
                                                                                    />{' '}
                                                                                    <FormattedMessage {...messages.editor_edit_window_body_varnish_matt}></FormattedMessage>
                                                                                </span>
                                                                                    </div>
                                                                                ) : null}

                                                                                {canDoRotateSides ? (
                                                                                    <>
                                                                                <span>
                                                                                     <FormattedMessage {...messages.editor_edit_window_body_front_face}></FormattedMessage>:{' '}
                                                                                    <input
                                                                                        type="radio"
                                                                                        checked={sideARotation && sideRotationChecked === sideARotation.uuid ? true : false}
                                                                                        onClick={e => doAction(e, 'frontface-angle-sides', sideARotation)}
                                                                                    />{' '}
                                                                                    <FormattedMessage {...messages.editor_edit_window_body_front_face_sideA}></FormattedMessage>{' '}
                                                                                    <input
                                                                                        type="radio"
                                                                                        checked={sideBRotation && sideRotationChecked === sideBRotation.uuid ? true : false}
                                                                                        onClick={e => doAction(e, 'frontface-angle-sides', sideBRotation)}
                                                                                    />{' '}
                                                                                    <FormattedMessage {...messages.editor_edit_window_body_front_face_sideB}></FormattedMessage>
                                                                                </span>
                                                                                    </>
                                                                                ) : null}

                                                                                {canDoFrontFaceRotation   ? (
                                                                                    <>
                                                                                        <span>   <FormattedMessage {...messages.editor_edit_window_body_front_face_rotation}></FormattedMessage>: {angleRotate}°</span>

                                                                                        { language == "cs" ?

                                                                                            <GlobalButtonFinalSmall
                                                                                                style={ {
                                                                                                    left: '0px',
                                                                                                    top:"9px",
                                                                                                    minHeight: '25px',
                                                                                                    borderRadius: '25px',
                                                                                                    paddingBottom: '0px',
                                                                                                    paddingTop: '0px',
                                                                                                } }
                                                                                                onClick={() => setRotationMode(true)}
                                                                                                className={'borderBlue'}
                                                                                            >
                                                                                                <FormattedMessage {...messages.editor_edit_window_body_front_face_rotation_button_set}></FormattedMessage>
                                                                                            </GlobalButtonFinalSmall> :
                                                                                            <GlobalButtonFinalSmall
                                                                                                style={  {
                                                                                                    left: '15px',
                                                                                                    top:"0px",
                                                                                                    minHeight: '25px',
                                                                                                    borderRadius: '25px',
                                                                                                    paddingBottom: '0px',
                                                                                                    paddingTop: '0px',
                                                                                                }}
                                                                                                onClick={() => setRotationMode(true)}
                                                                                                className={'borderBlue'}
                                                                                            >
                                                                                                <FormattedMessage {...messages.editor_edit_window_body_front_face_rotation_button_set}></FormattedMessage>
                                                                                            </GlobalButtonFinalSmall>
                                                                                        }
                                                                                        <div style={{ borderBottom: '1px solid lightgray',marginTop: "17px" }}></div>
                                                                                    </>
                                                                                ) : null}
                                                                            </div>

                                                                        </div>
                                                                    ) : null}

                                                                  {/*  {packageType === 'shrinks' ? (
                                                                        <div style={{ paddingBottom: '15px' }}>
                                                                            <h5 className={'designHeadline'}>  <FormattedMessage {...messages.editor_edit_window_body_cans_title}></FormattedMessage></h5>

                                                                            <div className={'optionsButtons'}></div>

                                                                            {packageType === 'shrinks' ? (
                                                                                <>
                                                                                    <span style={{ maxWidth: '115px' }}>{productInsideShrinkName}</span>

                                                                                    <GlobalButtonFinalSmall
                                                                                        style={{
                                                                                            left: 'unset',
                                                                                            right: '0',
                                                                                            float: 'right',
                                                                                            top: '8px',
                                                                                            minHeight: '25px',
                                                                                            borderRadius: '25px',
                                                                                            paddingBottom: '0px',
                                                                                            paddingTop: '0px',
                                                                                        }}
                                                                                        onClick={() => handleWindowInsideProductsShrink('illustrator')}
                                                                                        className={'borderBlue'}
                                                                                    >
                                                                                        {' '}
                                                                                        <FontAwesomeIcon
                                                                                            icon={faEllipsis}
                                                                                            style={{
                                                                                                fontSize: '14px',
                                                                                                marginRight: '7px',
                                                                                            }}
                                                                                        />
                                                                                        Set inside
                                                                                    </GlobalButtonFinalSmall>
                                                                                </>
                                                                            ) : null}

                                                                            {packageType === 'shrinks' ? (
                                                                                <>
                                                                                    <span>Rotation of cans</span>
                                                                                    <GlobalButtonFinalSmall
                                                                                        style={{
                                                                                            left: 'unset',
                                                                                            right: '0',
                                                                                            float: 'right',
                                                                                            top: '9px',
                                                                                            minHeight: '25px',
                                                                                            borderRadius: '25px',
                                                                                            paddingBottom: '0px',
                                                                                            paddingTop: '0px',
                                                                                        }}
                                                                                        onClick={() => setRotationModeCans(true)}
                                                                                        className={'borderBlue'}
                                                                                    >
                                                                                        Set
                                                                                    </GlobalButtonFinalSmall>
                                                                                </>
                                                                            ) : null}
                                                                        </div>
                                                                    ) : null}*/}

                                                                    {/*<div style={{ borderBottom: '1px solid lightgray' }}></div>*/}

                                                                    <div style={{ paddingBottom: '5px' }}>
                                                                        <h5 className={'designHeadline'}><FormattedMessage {...messages.editor_edit_window_body_textures_title}></FormattedMessage></h5>

                                                                        <div className={'optionsButtons'}></div>

                                                                        {initTextures ? (
                                                                            <div>
                                                                                <span><FormattedMessage {...messages.editor_edit_window_textures_design_title}></FormattedMessage></span>

                                                                                <GlobalButtonFinalSmall
                                                                                    style={{
                                                                                        left: 'unset',
                                                                                        right: '0',
                                                                                        float: 'right',
                                                                                        top: '10px',
                                                                                        minHeight: '25px',
                                                                                        borderRadius: '25px',
                                                                                        paddingBottom: '0px',
                                                                                        paddingTop: '0px',
                                                                                        paddingLeft: "13px",
                                                                                        paddingRight: "13px"
                                                                                    }}
                                                                                    onClick={() => setDesignPopupOpened(designPopupOpened ? false : true)}
                                                                                    className={'borderBlue'}
                                                                                >
                                                                                    {' '}
                                                                                    <FontAwesomeIcon
                                                                                        icon={faEllipsis}
                                                                                        style={{
                                                                                            fontSize: '14px',
                                                                                            marginRight: '7px',
                                                                                        }}
                                                                                    />{' '}
                                                                                    <FormattedMessage {...messages.editor_edit_window_textures_button_more}></FormattedMessage>
                                                                                </GlobalButtonFinalSmall>

                                                                                {isMainDesignActive && mainTextureBody?
                                                                                    <span
                                                                                        className={'bubbleStatus'}>
                                                                                                <svg
                                                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                                                    width="9" height="9"
                                                                                                    viewBox="0 0 9 9"
                                                                                                    fill="none">
                                                                                <circle cx="4.5" cy="4.5" r="4.5"
                                                                                        fill="#009E00" />
                                                                                                </svg>
                                                                                             <FormattedMessage {...messages.editor_edit_window_textures_design_status_active}></FormattedMessage>
                                                                                            </span>
                                                                                    : <span
                                                                                        className={'bubbleStatus'}>
                                                                                                <svg
                                                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                                                    width="9" height="9"
                                                                                                    viewBox="0 0 9 9"
                                                                                                    fill="none">
                                                                                <circle cx="4.5" cy="4.5" r="4.5"
                                                                                        fill="#808080" />
                                                                                                </svg>
                                                                                             <FormattedMessage {...messages.editor_edit_window_textures_design_status_inactive}></FormattedMessage>
                                                                                            </span>}



                                                                                <div
                                                                                    className={`${designPopupOpened ? 'active mapPopupUpload' : 'mapPopupUpload'}  `}
                                                                                    ref={ref}
                                                                                    style={{ height: '107px' }}>
                                                                                <ul>

                                                                                {/*              <li onClick={() =>       THREEController.changeTexture('bodyMainTexture', "/textures/500_invert.png", masterProductUUID, versionProductUUID)}>*/}
                                                                                {/*    <FontAwesomeIcon icon={faUpload} />*/}
                                                                                {/*    <span>Switch texture</span>*/}
                                                                                {/*</li>*/}
                                                                                        <li onClick={() => handleWindowEditor('illustrator', "main-design")}>
                                                                                            <FontAwesomeIcon icon={faUpload} />
                                                                                            <span> <FormattedMessage {...messages.editor_edit_window_textures_button_upload_illustrator}></FormattedMessage></span>
                                                                                        </li>
                                                                                        <li onClick={() => handleWindowEditor('manually', "main-design")}>
                                                                                            <FontAwesomeIcon icon={faUpload} />
                                                                                            <span> <FormattedMessage {...messages.editor_edit_window_textures_button_manual_upload}></FormattedMessage></span>
                                                                                        </li>
                                                                                        <hr />

                                                                                        <li onClick={() => updateOptionAPI('main-design', null)}>

                                                                                            <svg xmlns="http://www.w3.org/2000/svg"
                                                                                                 viewBox="0 0 384 512">
                                                                                                <path
                                                                                                    d="M324.5 411.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L214.6 256 347.1 123.5c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L192 233.4 59.5 100.9c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L169.4 256 36.9 388.5c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L192 278.6 324.5 411.1z" />
                                                                                            </svg>


                                                                                            <span><FormattedMessage {...messages.editor_edit_window_textures_button_remove}></FormattedMessage></span>
                                                                                        </li>
                                                                                    </ul>
                                                                                </div>

                                                                                {canDoMetallic ? (
                                                                                    <>
                                                                                        <span><FormattedMessage {...messages.editor_edit_window_textures_metalness_title}></FormattedMessage></span>

                                                                                        <GlobalButtonFinalSmall
                                                                                            style={{
                                                                                                left: 'unset',
                                                                                                right: '0',
                                                                                                float: 'right',
                                                                                                top: '10px',
                                                                                                minHeight: '25px',
                                                                                                borderRadius: '25px',
                                                                                                paddingBottom: '0px',
                                                                                                paddingTop: '0px',
                                                                                                paddingLeft: "13px",
                                                                                                paddingRight: "13px"
                                                                                            }}
                                                                                            onClick={() => setMetalnessPopupOpened(metalnessPopupOpened ? false : true)}
                                                                                            className={'borderBlue'}
                                                                                        >
                                                                                            <FontAwesomeIcon
                                                                                                icon={faEllipsis}
                                                                                                style={{
                                                                                                    fontSize: '14px',
                                                                                                    marginRight: '7px',
                                                                                                }}
                                                                                            />{' '}
                                                                                            <FormattedMessage {...messages.editor_edit_window_textures_button_more}></FormattedMessage>
                                                                                        </GlobalButtonFinalSmall>



                                                                                        { isMetallicDesignActive && metallicTextureBody ?
                                                                                            <span
                                                                                                className={'bubbleStatus'}>
                                                                                                <svg
                                                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                                                    width="9" height="9"
                                                                                                    viewBox="0 0 9 9"
                                                                                                    fill="none">
                                                                                <circle cx="4.5" cy="4.5" r="4.5"
                                                                                        fill="#009E00" />
                                                                                                </svg>
                                                                                             <FormattedMessage {...messages.editor_edit_window_textures_design_status_active}></FormattedMessage>
                                                                                            </span>
                                                                                            : <span
                                                                                                className={'bubbleStatus'}>
                                                                                                <svg
                                                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                                                    width="9" height="9"
                                                                                                    viewBox="0 0 9 9"
                                                                                                    fill="none">
                                                                                <circle cx="4.5" cy="4.5" r="4.5"
                                                                                        fill="#808080" />
                                                                                                </svg>
                                                                                             <FormattedMessage {...messages.editor_edit_window_textures_design_status_inactive}></FormattedMessage>
                                                                                            </span>}


                                                                                        <div className={`${metalnessPopupOpened ? 'active mapPopupUpload' : 'mapPopupUpload'}  `} ref={ref2}>
                                                                                            <ul>
                                                                                                <li onClick={() => handleWindowEditor('illustrator', "metallic-design")}>
                                                                                                    <FontAwesomeIcon icon={faUpload} />
                                                                                                    <span><FormattedMessage {...messages.editor_edit_window_textures_button_upload_illustrator}></FormattedMessage></span>
                                                                                                </li>
                                                                                                <li onClick={() => handleWindowEditor('manually', "metallic-design")}>
                                                                                                    <FontAwesomeIcon icon={faUpload} />
                                                                                                    <span><FormattedMessage {...messages.editor_edit_window_textures_button_manual_upload}></FormattedMessage></span>
                                                                                                </li>
                                                                                                <hr />
                                                                                                <li onClick={ () => updateOptionAPI('metallic-design', null)}>
                                                                            <svg xmlns="http://www.w3.org/2000/svg"
                                                                                 viewBox="0 0 384 512">
                                                                                <path
                                                                                    d="M324.5 411.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L214.6 256 347.1 123.5c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L192 233.4 59.5 100.9c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L169.4 256 36.9 388.5c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L192 278.6 324.5 411.1z" />
                                                                            </svg>


                                                                            <span><FormattedMessage {...messages.editor_edit_window_textures_button_remove}></FormattedMessage></span>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </>
                                                        ) : null}
                                                        {canDoAlpha ? (
                                                            <>
                                                                <span><FormattedMessage {...messages.editor_edit_window_textures_alpha_title}></FormattedMessage></span>

                                                                <GlobalButtonFinalSmall
                                                                    style={{
                                                                        left: 'unset',
                                                                        right: '0',
                                                                        float: 'right',
                                                                        top: '10px',
                                                                        minHeight: '25px',
                                                                        borderRadius: '25px',
                                                                        paddingBottom: '0px',
                                                                        paddingTop: '0px',
                                                                        paddingLeft: "13px",
                                                                        paddingRight: "13px"
                                                                    }}
                                                                    onClick={() => setAlphaPopupOpened(alphaPopupOpened ? false : true)}
                                                                    className={'borderBlue'}
                                                                >
                                                                    <FontAwesomeIcon
                                                                        icon={faEllipsis}
                                                                        style={{
                                                                            fontSize: '14px',
                                                                            marginRight: '7px',
                                                                        }}
                                                                    />{' '}
                                                                    <FormattedMessage {...messages.editor_edit_window_textures_button_more}></FormattedMessage>
                                                                </GlobalButtonFinalSmall>

                                                                { isAlphaDesignActive && alphaTextureBody?
                                                                    <span
                                                                        className={'bubbleStatus'}>
                                                                                                <svg
                                                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                                                    width="9" height="9"
                                                                                                    viewBox="0 0 9 9"
                                                                                                    fill="none">
                                                                                <circle cx="4.5" cy="4.5" r="4.5"
                                                                                        fill="#009E00" />
                                                                                                </svg>
                                                                                             <FormattedMessage {...messages.editor_edit_window_textures_design_status_active}></FormattedMessage>
                                                                                            </span>
                                                                    : <span
                                                                        className={'bubbleStatus'}>
                                                                                                <svg
                                                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                                                    width="9" height="9"
                                                                                                    viewBox="0 0 9 9"
                                                                                                    fill="none">
                                                                                <circle cx="4.5" cy="4.5" r="4.5"
                                                                                        fill="#808080" />
                                                                                                </svg>
                                                                                             <FormattedMessage {...messages.editor_edit_window_textures_design_status_inactive}></FormattedMessage>
                                                                                            </span>}


                                                                <div className={`${alphaPopupOpened ? 'active mapPopupUpload' : 'mapPopupUpload'}  `} ref={ref4}>
                                                                    <ul>
                                                                        <li onClick={() => handleWindowEditor('illustrator', "alpha-design")}>
                                                                            <FontAwesomeIcon icon={faUpload} />
                                                                            <span><FormattedMessage {...messages.editor_edit_window_textures_button_upload_illustrator}></FormattedMessage></span>
                                                                        </li>
                                                                        <li onClick={() => handleWindowEditor('manually', "alpha-design")}>
                                                                            <FontAwesomeIcon icon={faUpload} />
                                                                            <span><FormattedMessage {...messages.editor_edit_window_textures_button_manual_upload}></FormattedMessage></span>
                                                                        </li>
                                                                        <hr />

                                                                        <li onClick={() => updateOptionAPI('alpha-design', null)}>
                                                                                                    <svg xmlns="http://www.w3.org/2000/svg"
                                                                                                         viewBox="0 0 384 512">
                                                                                                        <path
                                                                                                            d="M324.5 411.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L214.6 256 347.1 123.5c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L192 233.4 59.5 100.9c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L169.4 256 36.9 388.5c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L192 278.6 324.5 411.1z" />
                                                                                                    </svg>
                                                                            <span><FormattedMessage {...messages.editor_edit_window_textures_button_remove}></FormattedMessage></span>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </>
                                                        ) : null}

                                                     <span className={'downloadAdobe'}>
                                                        <FontAwesomeIcon
                                                            id={"downloadAdobe"}
                                                            data-intercom-target="downloadAdobe"
                                                            icon={faDownload}
                                                            onClick={() => downloadSketch()}
                                                            style={{
                                                                fontSize: '14px',
                                                                marginRight: '7px',
                                                            }}
                                                        />
                                                        <span onClick={() => downloadSketch()}><FormattedMessage {...messages.editor_edit_window_textures_button_download}></FormattedMessage></span>
                                                    </span>


                                                    </div>
                                                ) : (
                                                    <div

                                                        className={`initTextures down    ${isCzech ? 'isCzech' : ""} `}>

                                                        <GlobalButtonFinalSmall
                                                            id={"downloadSketch"}
                                                            onClick={() => downloadSketch()}
                                                            style={{
                                                                minHeight: 'unset',
                                                                height: '29px',
                                                                paddingTop: '4px',
                                                                padding: '5px 18px !important',
                                                                marginTop: '10px',
                                                            }}
                                                            className={'borderBlue'}
                                                        >
                                                            <FontAwesomeIcon
                                                                icon={faDownload}
                                                                style={{
                                                                    fontSize: '14px',
                                                                    marginRight: '7px',
                                                                }}
                                                            />{' '}
                                                            <FormattedMessage {...messages.editor_edit_window_textures_button_download}></FormattedMessage>
                                                        </GlobalButtonFinalSmall>


                                                        <div className={'dottedLine'}>
                                                            <span><FormattedMessage {...messages.editor_edit_window_textures_or}></FormattedMessage></span>
                                                        </div>

                                                        <span><FormattedMessage {...messages.editor_edit_window_textures_description}></FormattedMessage></span>
                                                        <GlobalButtonFinalSmall
                                                            style={{
                                                                left: 'unset',
                                                                right: '0',
                                                                float: 'left',
                                                                top: '10px',
                                                                minHeight: '25px',
                                                                borderRadius: '25px',
                                                                paddingBottom: '0px',
                                                                paddingTop: '0px',
                                                            }}
                                                            onClick={() => setInitTextures(true)}
                                                            className={'borderBlue'}
                                                        >
                                                            <FontAwesomeIcon
                                                                icon={faHand}
                                                                style={{
                                                                    fontSize: '14px',

                                                                    marginRight: '7px',
                                                                }}
                                                            />{' '}
                                                            <FormattedMessage {...messages.editor_edit_window_textures_button_manually}></FormattedMessage>
                                                        </GlobalButtonFinalSmall>
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                    </div>


                                                            <LoaderUI className={`loader-editor-ui ${loadTransitionProductsShowUI ? 'showTransition' : 'hideTransition'} ${!loadProductsShowUI ? 'hiddeComplete' : ''} `}>
                                                                <img src={'/logoAnimate.svg'} />
                                                            </LoaderUI>
                                                        </EditorLeftActionsBarWindow>
                                            : null}


                        </EditorLeftActionsBarWrapper>


                            {!commentCanvasShow ?
                                <EditorRightActionsBar id="scene-overlay-buttons-right"
                                                       data-intercom-target="scene-overlay-buttons-right"
                                                       className={`${!setRotationActive ? 'active' : ''}`}>

                                    {editorMode !== "view" && authData.teamPlan && authData.teamPlan !== "Free" ?
                                        <FormattedMessage {...messages.editor_tooltip_comments}>
                                            {(msg) => (
                                                <button
                                                    data-tip={msg}
                                                    id="editorCommentsButton"
                                                    data-intercom-target="editorCommentsButton"
                                                    data-place="left"
                                                    data-delay-show="1000"
                                                    style={{ marginTop: '10px' }}
                                                    className={`${commentActive ? 'active' : ''}`}
                                                    onClick={!commentActive ? () => openWindowPopup('comment') : () => closeComments()}
                                                >
                                                    <FontAwesomeIcon icon={faComment} />
                                                </button>
                                            )}
                                        </FormattedMessage>
                                    : null}

                                    {editorMode !== "view" && authData.teamPlan && authData.teamPlan === "Free" ?
                                        <FormattedMessage {...messages.editor_tooltip_comments_locked}>
                                            {(msg) => (
                                                <button
                                                    id={"faRightEditorCommentBtn"}
                                                    data-tip={msg}
                                                    data-place="left"
                                                    data-intercom-target="editorCommentsButtonLocked"
                                                    data-delay-show="1000"
                                                    style={{ marginTop: '10px' }}
                                                    className={`${commentActive ? 'active' : ''}`}
                                                    onClick={() => triggerAlert(language === "cs" ? <a href='/subscription'>Komentáře jsou dostupné od plánu basic, upgrade zde</a> : <a href='/subscription'>Comments are available from the basic plan, upgrade here</a>)}
                                                >
                                                    <FontAwesomeIcon icon={faComment} />

                                                </button>
                                            )}
                                        </FormattedMessage>
                                        : null}



                                    <FormattedMessage {...messages.editor_tooltip_view}>
                                        {(msg) => (
                                            <button
                                                id={"faRightEditorViewBtn"}
                                                data-intercom-target="faRightEditorViewBtn"
                                                data-tip={msg}
                                                data-place="left"
                                                data-delay-show="1000"
                                                style={{ marginTop: '10px' }}
                                                className={`${eyeActive ? 'active' : ''}`}
                                                onClick={() => openWindowPopup('eye')}
                                            >
                                                <FontAwesomeIcon icon={faEye} />
                                            </button>
                                        )}
                                    </FormattedMessage>

                                    <FormattedMessage {...messages.editor_tooltip_grid}>
                                        {(msg) => (
                                            <button
                                                id={"faRightEditorGridBtn"}
                                                data-intercom-target="faRightEditorGridBtn"
                                                data-tip={msg}
                                                data-place="left"
                                                data-delay-show="1000"
                                                style={{ marginTop: '10px' }}
                                                className={`${gridButtonChecked ? 'active' : ''}`}
                                                onClick={() => changeGridButton(gridButtonChecked ? false : true)}
                                            >
                                                <FontAwesomeIcon icon={faGrid5} />
                                            </button>
                                        )}
                                    </FormattedMessage>


                                    {/*   <FormattedMessage {...messages.editor_tooltip_ruler}>
                                    {(msg) => (
                                        <button
                                            data-tip={msg}
                                            data-place="left"
                                            data-delay-show="1000"
                                            style={{ marginTop: '10px' }}
                                            className={`${rulerButtonChecked ? 'active' : ''}`}
                                            onClick={() => changeRulerButton(rulerButtonChecked ? false : true)}
                                        >
                                            <FontAwesomeIcon icon={faRulerCombined} />
                                        </button>
                                    )}
                                </FormattedMessage>*/}

                                    {authData.userDeveloper ?
                                        <button
                                            data-tip="Developer Tools"
                                            data-place="left"
                                            id={'faRightEditorDeveloperBtn'}
                                            data-delay-show="1000"
                                            style={{ marginTop: '10px' }}
                                            className={`${developerButtonChecked ? 'active' : ''}`}
                                            onClick={() => changeDeveloperButton(developerButtonChecked ? false : true)}
                                        >
                                            <FontAwesomeIcon icon={faGears} />
                                        </button> : null
                                    }

                                    {authData.teamPlan && authData.teamPlan !== "Free" ?
                                        <button
                                            data-tip="Quick preview"
                                            data-place="left"
                                            id={'faScreenshot'}
                                            data-delay-show="1000"
                                            style={{ marginTop: '10px' }}

                                            onClick={() => makeScreenshot()}
                                        >
                                            <FontAwesomeIcon icon={faCamera} />
                                        </button>
                                        : null}

                                    { authData.teamPlan && authData.teamPlan === "Free" ?
                                        <button
                                            data-tip="Quick preview"
                                            data-place="left"
                                            id={'faScreenshot'}
                                            data-delay-show="1000"
                                            style={{ marginTop: '10px' }}

                                            onClick={() => triggerAlert(language === "cs" ? <a href='/subscription'>Rychlý packshot je dostupný od plánu basic, upgrade zde</a> : <a href='/subscription'>Quick packshot is available from the basic plan, upgrade here</a>)}
                                        >
                                            <FontAwesomeIcon icon={faCamera} />
                                        </button>
                                        : null}





                                    <EditorRightActionsBarWindow
                                        className={`rightWindowPopup commentPopup ${commentActive ? 'active' : ''}`}>


                                        <div className={'commentsWrapepr'}>


                                            <StyledCommentsHeader>
                                                <div className={'commentHeader'}>
                                                    <h4 style={{ float: 'left', margin: '0' }}>
                                                        <FormattedMessage {...messages.editor_tooltip_comments}></FormattedMessage>
                                                    </h4>

                                                    <button className={'closeButton'} style={{ right: '-7px' }}
                                                            onClick={() => closeComments()}>
                                                        <svg xmlns="http://www.w3.org/2000/svg"
                                                             viewBox="0 0 384 512">
                                                            <path
                                                                d="M324.5 411.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L214.6 256 347.1 123.5c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L192 233.4 59.5 100.9c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L169.4 256 36.9 388.5c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L192 278.6 324.5 411.1z" />
                                                        </svg>


                                                    </button>

                                                    <div className={'comments-header'}>

                                                        <button className={'addNew'}
                                                                onClick={() => activateCommentsNew(true)}>
                                                            <FontAwesomeIcon icon={faPlus} />
                                                        </button>

                                                        <ul className="nav nav-tabs tpl-minimal-tabs animate"
                                                            role="tablist">
                                                            <li className="nav-item" role="typography"
                                                                onClick={() => filterComments('all')}>
                                                                <a data-closemodalautocomplete={true}
                                                                   data-closewhisperer={true}
                                                                    //   onClick={() => setActiveTab('version')}
                                                                   className={commentsFilterType === "all" ? `nav-link active ` : `nav-link ` }>
                                                                    <FormattedMessage {...messages.editor_comments_all}></FormattedMessage>
                                                                </a>
                                                            </li>

                                                            <li className="nav-item" role="typography"
                                                                onClick={() => filterComments('unresolved')}>
                                                                <a data-closemodalautocomplete={true}
                                                                   data-closewhisperer={true}
                                                                   style={language === "cs" ? {fontSize:"13px"} : null}
                                                                    //   onClick={() => setActiveTab('product')}
                                                                   className={commentsFilterType !== "all" ? `nav-link active ` : `nav-link ` }>
                                                                    <FormattedMessage {...messages.editor_comments_unresolved}></FormattedMessage>
                                                                </a>
                                                            </li>
                                                        </ul>


                                                    </div>

                                                </div>
                                          </StyledCommentsHeader>


                                            <div
                                                style={{    marginTop: "110px"}}
                                                className={`commentsContent  ${editorMode === 'edit' ? '' : 'off'}`}
                                            >

                                                <StyledComments>

                                                    <div className={'comments'}>


                                                        <Comment
                                                            addTempComment={addTempComment}
                                                            activeComment={true}
                                                            userAvatar={authData.userAvatar}
                                                            userName={authData.userName}
                                                            setActiveComment={setActiveCommentFc}
                                                            countComments={''}
                                                            versionUUID={versionProductUUID}
                                                            position={newCommentPosition}
                                                            hide={newComment ? false : true}
                                                            type={'new'}
                                                            cancelAddComment={cancelAddComment}
                                                            finishComments={finishComments}
                                                            toggleInput={(toggleInput: () => void) => {
                                                                handleClickNewComment = toggleInput;
                                                            }}
                                                        />


                                                        {allComments.map((value, index) => {

                                                            return (
                                                                <Comment
                                                                    addTempComment={addTempComment}
                                                                    triggerDeleteComment={triggerDeleteComment}
                                                                    myAvatar={authData.userAvatar}
                                                                    activeComment={!newComment && activeComment === value.number}
                                                                    setActiveComment={setActiveCommentFc}
                                                                    userAvatar={value.created.user.avatar}
                                                                    userName={value.created.user.full_name}
                                                                    created={value.created}
                                                                    commentUUID={value.uuid}
                                                                    status={value.status.status}
                                                                    text={value.text}
                                                                    number={value.number}
                                                                    commentsAll={value.comments}
                                                                    countComments={allComments.length}
                                                                    versionUUID={versionProductUUID}
                                                                    position={newCommentPosition}
                                                                    hide={false}
                                                                    cancelAddComment={cancelAddComment}
                                                                    finishComments={finishComments}
                                                                    toggleInput={(toggleInput: () => void) => {
                                                                        handleClickNewComment = toggleInput;
                                                                    }}

                                                                />
                                                            );
                                                        })}


                                                    </div>
                                                </StyledComments>


                                            </div>
                                        </div>


                                    </EditorRightActionsBarWindow>
                                    <EditorRightActionsBarWindow
                                        className={`rightWindowPopup eyePopup ${eyeActive ? 'active' : ''}`}>
                                        <div className={'cubeHeader'}>
                                            <h4 style={{ float: 'left', margin: '0' }}>
                                                <FontAwesomeIcon style={{ marginRight: '10px' }} icon={faEye} />
                                                <FormattedMessage {...messages.editor_tooltip_view}></FormattedMessage>
                                            </h4>

                                            <button className={'closeButton'} style={{ right: '-7px' }}
                                                    onClick={() => setEyeActive(false)}>
                                                <svg xmlns="http://www.w3.org/2000/svg"
                                                     viewBox="0 0 384 512">
                                                    <path
                                                        d="M324.5 411.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L214.6 256 347.1 123.5c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L192 233.4 59.5 100.9c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L169.4 256 36.9 388.5c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L192 278.6 324.5 411.1z" />
                                                </svg>


                                            </button>
                                        </div>

                                        <div
                                            style={{
                                                borderRadius: '15px',
                                                paddingLeft: '15px',
                                                marginTop: '10px !important',
                                                paddingRight: '15px',
                                                paddingTop: '5px',
                                            }}
                                            className={`cubeContent  ${editorMode === 'edit' ? '' : 'off'}`}
                                        >
                                            <h5 style={{ textAlign: 'left', margin: '0' }}>
                                                <FormattedMessage {...messages.editor_background_title}></FormattedMessage>
                                            </h5>
                                            <div className={'colorPickerScene'}>
                                                {backgroundColors.map((value, index) => {
                                                    return (
                                                        <>
                                                            {/*<p>{value.type}</p>*/}
                                                            {value.type === 'solidcolor' ? (
                                                                <button
                                                                    data-tip={`Color: ${value.background_color}`}
                                                                    data-place="bottom"
                                                                    data-delay-show="1000"
                                                                    currentitem="false"
                                                                    className={`${backgroundEditor === value.background_color ? 'activeButton' : ''}`}
                                                                    onClick={() => setBackgroundColor(value.background_color, value.grid_color, value.grid_opacity)}
                                                                    style={{ background: value.background_color }}
                                                                ></button>
                                                            ) : null}
                                                        </>
                                                    );
                                                })}
                                            </div>

                                            <div className={'colorPickerScene'}>
                                                {backgroundColors.map((value, index) => {
                                                    return (
                                                        <>
                                                            {value.type === 'gradient' ? (
                                                                <button
                                                                    data-tip={`Color: ${value.name}`}
                                                                    data-place="bottom"
                                                                    data-delay-show="1000"
                                                                    currentitem="false"
                                                                    className={`${backgroundEditor === value.file_url ? 'activeButton' : ''}`}
                                                                    onClick={() => setBackgroundColorGradient(value.file_url, value.grid_color, value.grid_opacity)}
                                                                    style={{
                                                                        background: value.background_color_css,
                                                                        background: value.background_gradient_css,
                                                                    }}
                                                                ></button>
                                                            ) : null}
                                                        </>
                                                    );
                                                })}
                                            </div>
                                        </div>


                                    </EditorRightActionsBarWindow>

                                </EditorRightActionsBar>
                            : null}


                            <EditorSetFrontFaceRotationTop className={` ${setRotationActive ? 'active' : ''}`}>
                                <h1> <FormattedMessage {...messages.editor_rotate_left_right_description}></FormattedMessage></h1>

                                <div className={'angleRotation'}>
                                    <input value={angleRotate} onChange={handleChangeAngle} /> <span>°</span>
                                </div>
                            </EditorSetFrontFaceRotationTop>

                            <EditorSetFrontFaceRotationLeft className={` ${setRotationActive &&packageType === "shrinks" ? 'active' : ''}`}>
                                <div className={'shrinkProductRotationChooser'}>
                                    {shrinkRows.map((item, index) => {
                                        return (
                                            <div className={'shrinkRow'} style={{ display: 'flex' }}>
                                                {shrinkColumns.map((itemColumn, indexColumn) => {
                                                    return (
                                                        <div className={'shrinkColumn'} style={{ display: 'flex' }}>
                                                            <div
                                                                id={'shrinkProduct' + (indexColumn + 1 + index * shrinkRows.length)}
                                                                className={'shrinkProduct'}
                                                                style={{ display: 'flex' }}
                                                                onClick={() => setUpShrinkProductRotationCtrl(indexColumn + 1 + index * shrinkRows.length)}
                                                            ></div>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        );
                                    })}
                                </div>

                            </EditorSetFrontFaceRotationLeft>

                            <EditorSetFrontFaceRotationLine className={` ${setRotationActive ? 'active' : ''}`}></EditorSetFrontFaceRotationLine>

                            <EditorSetFrontFaceRotationBottom className={` ${setRotationActive ? 'active' : ''}`}>
                                <GlobalButtonFinal className={'backgroundGray cancel btn-circle'} style={{ marginLeft: '-160px', color: 'white', position: 'absolute' }} onClick={() => cancelRotationMode()}>
                                    <FormattedMessage {...messages.editor_button_cancel}></FormattedMessage>
                                </GlobalButtonFinal>

                                <GlobalButtonFinal
                                    className={'backgroundBlue  btn-circle'}
                                    style={{ marginLeft: '40px', position: 'absolute' }}
                                    onClick={isShrink ? () => setProductInsideShrinkRotationAPI() : e => doAction(e, 'frontface-angle', angleRotate)}
                                >
                                    <FontAwesomeIcon style={{ marginRight: '5px' }} icon={faCheck} />
                                    <FormattedMessage {...messages.editor_button_ok}></FormattedMessage>
                                </GlobalButtonFinal>
                            </EditorSetFrontFaceRotationBottom>

                 </>

                </>
            ) : (
                <>
                    {plugin ?
                        null
                        : <div
                            dangerouslySetInnerHTML={{
                                __html: `<style>#intercom-container,
                    #intercom-frame,
                    .intercom-lightweight-app{
                      display:none;
                    }</style>`,
                            }}
                        />}

                  {/*  <ReactSlider
                        className="horizontal-slider"
                        value={valueRotationX}
                        defaultValue={0}
                        thumbClassName="example-thumb"
                        trackClassName="example-track"
                        onChange={ (value, index) => setXRotationCamera(value) }
                    />*/}

                    <div id={'ActionsPlugin'}
                         style={{ bottom: '35px', left: '30px', position: 'absolute', zIndex: '99999' }}>
                        <button
                            onClick={() => rotateProduct()}
                            style={{
                                background: 'transparent',
                                padding: '5px',
                                border: 'none !important',
                                maxWidth: '35px',
                                position:"relative",
                                top:"5px",
                                left:"-5px"
                            }}
                        >

                            {!productRotating ? <img src={'/images/play.png'} style={{ maxWidth: '100%' }} /> : <img src={'/images/pause.png'} style={{ maxWidth: '100%' }} />}
                        </button>


                    </div>
                </>
            )}

            <div
                id="scene-container"
                data-closemodalmenu={true}
                style={
                    plugin
                        ? {
                              position: 'relative',
                              top: '0px',
                              height: '100%',
                              minHeight: '100%',
                              width: '100%',
                              float: 'left',
                          }
                        : { position: 'fixed', top: '0', height: '100%', minHeight: '100%', width: '100%', float: 'left' }
                }
            >

            </div>


            <ModalsWrapper className={`colorsWrapper  ${showEditorPackageOpeningsModalTransition ? 'showTransition' : 'hideTransition'} ${!showEditorPackageOpeningsModal ? 'hiddeComplete' : ''}`}>
                <ModalWindow id={'packageOpeningModal'} className={`colorsList ${showEditorPackageOpeningsModal ? '' : 'hideModal'}`} style={{ minHeight: '400px' }}>
                    <div className={`openingOptions optionsBox  ${actionMenu == 'full' ? 'active' : ''}`}>
                        <div className={'header'} style={{ position: 'absolute', padding: '0', right: '15px' }}>
                            <button className={'closeButton'}
                                    onClick={() => changeEditorPackageOpeningsShow(false, null)}>

                                <svg xmlns="http://www.w3.org/2000/svg"
                                     viewBox="0 0 384 512">
                                    <path
                                        d="M324.5 411.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L214.6 256 347.1 123.5c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L192 233.4 59.5 100.9c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L169.4 256 36.9 388.5c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L192 278.6 324.5 411.1z" />
                                </svg>


                            </button>
                        </div>

                        <div style={{ paddingTop: '5px', display: 'grid' }}>
                            <h5 style={{ marginTop: '10px' }} className={'designHeadline'}>
                                Choose opening
                            </h5>

                            <div className={'optionsButtons'}></div>
                        </div>

                        <div style={{ paddingBottom: '5px' }} className={'openingTypeList'}>
                            <ul className={'openingTypeList'}>


                            {packageOpenings !== null && packageOpenings.length > 0 ? (
                                    <>
                                        {packageOpenings.map(openingItem => {
                                            return (
                                                <div onClick={() => changeOpening(openingItem.uuid)}>
                                                    <img
                                                        style={openingItem.thumbnail.fallback ? {} : { filter: 'invert(1)' }}
                                                        src={openingItem.thumbnail.fallback ? openingItem.thumbnail.fallback : '/images/logoMobile.svg'} />

                                                    <span>{openingItem.name}</span>
                                                </div>
                                            );
                                        })}
                                    </>
                            ) : null}
                            </ul>
                        </div>
                    </div>
                </ModalWindow>
            </ModalsWrapper>

            <ModalsWrapper
                onClick={(e) => closeModalOutsideClickColors(e)}
                data-closemodalcolors={true}
                className={`colorsWrapper  ${showEditorColorsModalTransition ? 'showTransition' : 'hideTransition'} ${!showEditorColorsModal ? 'hiddeComplete' : ''}`}>
                <ModalWindow id={'colorsModal'} className={`colorsList ${showEditorColorsModal ? '' : 'hideModal'}`} style={{ minHeight: '400px' }}>
                    <div className={`openingOptions optionsBox  ${actionMenu == 'full' ? 'active' : ''}`}>
                        <div className={'header'} style={{ position: 'absolute', padding: '0', right: '15px' }}>

                            <button className={'closeButton'} onClick={() => changeEditorColorsShow(false, null)}>

                                <svg xmlns="http://www.w3.org/2000/svg"
                                     viewBox="0 0 384 512">
                                    <path
                                        d="M324.5 411.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L214.6 256 347.1 123.5c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L192 233.4 59.5 100.9c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L169.4 256 36.9 388.5c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L192 278.6 324.5 411.1z" />
                                </svg>

                            </button>
                        </div>

                        <div style={{ paddingTop: '5px', display: 'grid' }}>


                            {activeColorChoose === 'tabs' ?
                                <h5 style={{ marginTop: '10px' }} className={'designHeadline'}>
                                    <FormattedMessage {...messages.editor_color_window_tabs_title}></FormattedMessage>
                                </h5>
                           :null }

                            {activeColorChoose === 'shells' ?
                                <h5 style={{ marginTop: '10px' }} className={'designHeadline'}>
                                    <FormattedMessage {...messages.editor_color_window_shell_title}></FormattedMessage>
                                </h5>
                                :null }
                            {activeColorChoose === 'bottles' ?
                                <h5 style={{ marginTop: '10px' }} className={'designHeadline'}>
                                    <FormattedMessage {...messages.editor_color_window_bottle_title}></FormattedMessage>
                                </h5>
                                :null }
                            {activeColorChoose === 'body' ?
                                <h5 style={{ marginTop: '10px' }} className={'designHeadline'}>
                                    <FormattedMessage {...messages.editor_color_window_body_title}></FormattedMessage>
                                </h5>
                                :null }
                            {activeColorChoose === 'opening' ?
                                <h5 style={{ marginTop: '10px' }} className={'designHeadline'}>
                                    <FormattedMessage {...messages.editor_color_window_opening_title}></FormattedMessage>
                                </h5>
                                :null }
                            {activeColorChoose === 'fluids' ?
                                <h5 style={{ marginTop: '10px' }} className={'designHeadline'}>
                                    <FormattedMessage {...messages.editor_color_window_bottle_title}></FormattedMessage>
                                </h5>
                                :null }

                            <div className={'optionsButtons'}></div>
                        </div>

                        <div style={{ paddingBottom: '5px' }} className={'colorsList'}>
                        <ul className={'colorsList'}>
                            {openingColors !== null && openingColors.length > 0 && activeColorChoose === 'opening' ? (
                                <>
                                    {openingColors.map((openingColor, indexTabColor) => {

                                        return (
                                            <li>
                                                <button
                                                    data-actionuuid={openingColor.uuid}
                                                    data-actionkey={'fluid-color'}
                                                    data-actionvalue={openingColor.value}
                                                    data-offset="{'right': 10}"
                                                    data-tip={openingColor.name}
                                                    data-place="bottom"
                                                    data-delay-show="1000"
                                                    style={{ background: '#' + openingColor.value.replace('#', '') }}
                                                    onClick={e => doAction(e, 'opening-color', openingColor.uuid, openingColor.name)}
                                                    className={openingColorUUID == openingColor.uuid ? 'active' : null}
                                                >
                                                    {/*<h5>{shellColor.name}</h5>*/}
                                                </button>
                                                <span>{openingColor.name}</span>
                                            </li>
                                        );
                                    })}
                                </>
                            ) : null}
                            {bodyColors !== null && bodyColors.length > 0 && activeColorChoose === 'body' ? (
                                <>
                                    {bodyColors.map((bodyColor, indexTabColor) => {

                                        return (
                                            <li>
                                                <button
                                                    data-actionuuid={bodyColor.uuid}
                                                    data-actionkey={'body-color'}
                                                    data-actionvalue={bodyColor.value}
                                                    data-offset="{'right': 10}"
                                                    data-tip={bodyColor.name}
                                                    data-place="bottom"
                                                    data-delay-show="1000"
                                                    style={{ background: '#' + bodyColor.value.replace('#', '') }}
                                                    onClick={e => doAction(e, 'body-color', bodyColor.uuid, bodyColor.name)}
                                                    className={bodyColorUUID == bodyColor.uuid ? 'active' : null}
                                                >
                                                    {/*<h5>{shellColor.name}</h5>*/}
                                                </button>
                                                <span>{bodyColor.name}</span>
                                            </li>
                                        );
                                    })}
                                </>
                            ) : null}
                            {fluidColors !== null && fluidColors.length > 0 && activeColorChoose === 'fluids' ? (
                                <>
                                    {fluidColors.map((fluidColor, indexTabColor) => {

                                        return (
                                            <li>
                                                <button
                                                    data-actionuuid={fluidColor.uuid}
                                                    data-actionkey={'fluid-color'}
                                                    data-actionvalue={fluidColor.value}
                                                    data-offset="{'right': 10}"
                                                    data-tip={fluidColor.name}
                                                    data-place="bottom"
                                                    data-delay-show="1000"
                                                    style={{ background: '#' + fluidColor.value.replace('#', '') }}
                                                    onClick={e => doAction(e, 'fluid-color', fluidColor.uuid, fluidColor.name)}
                                                    className={fluidColorUUID == fluidColor.uuid ? 'active' : null}
                                                >
                                                    {/*<h5>{shellColor.name}</h5>*/}
                                                </button>
                                                <span>{fluidColor.name}</span>
                                            </li>
                                        );
                                    })}
                                </>
                            ) : null}
                            {bottleColors !== null && bottleColors.length > 0 && activeColorChoose === 'bottles' ? (
                                <>
                                    {bottleColors.map((bottleColor, indexTabColor) => {

                                        return (
                                            <li>
                                                <button
                                                    data-actionuuid={bottleColor.uuid}
                                                    data-actionkey={'bottle-color'}
                                                    data-actionvalue={bottleColor.value}
                                                    data-offset="{'right': 10}"
                                                    data-tip={bottleColor.name}
                                                    data-place="bottom"
                                                    data-delay-show="1000"
                                                    style={{ background: '#' + bottleColor.value.replace('#', '') }}
                                                    onClick={e => doAction(e, 'bottle-color', bottleColor.uuid, bottleColor.name)}
                                                    className={bottleColorUUID == bottleColor.uuid ? 'active' : null}
                                                >
                                                    {/*<h5>{shellColor.name}</h5>*/}
                                                </button>
                                                <span>{bottleColor.name}</span>
                                            </li>
                                        );
                                    })}
                                </>
                            ) : null}
                                {tabsColors !== null && tabsColors.length > 0 && activeColorChoose === 'tabs' ? (
                                    <>
                                        {tabsColors.map((tabColors, indexTabColor) => {

                                            return (
                                                <li>
                                                    <button
                                                        data-actionuuid={tabColors.uuid}
                                                        data-actionkey={'tabs-color'}
                                                        data-actionvalue={tabColors.value}
                                                        data-offset="{'right': 10}"
                                                        data-tip={tabColors.name}
                                                        data-place="bottom"
                                                        data-delay-show="1000"
                                                        style={{ background: '#' + tabColors.value.replace('#', '') }}
                                                        onClick={e => doAction(e, 'tabs-color', tabColors.uuid, tabsColors.name)}
                                                        className={tabColorUUID == tabColors.uuid ? 'active' : null}
                                                    >
                                                        {/*<h5>{shellColor.name}</h5>*/}
                                                    </button>
                                                    <span>{tabColors.name}</span>
                                                </li>
                                            );
                                        })}
                                    </>
                                ) : null}
                                {shellColors !== null && shellColors.length > 0 && activeColorChoose === 'shells' ? (
                                    <>
                                        {shellColors.map((shellColor, indexTabColor) => {

                                            return (
                                                <li>
                                                    <button
                                                        data-actionuuid={shellColor.uuid}
                                                        data-actionkey={'shell-color'}
                                                        data-actionvalue={shellColor.value}
                                                        data-offset="{'right': 10}"
                                                        data-tip={shellColor.name}
                                                        data-place="bottom"
                                                        data-delay-show="1000"
                                                        style={{ background: '#' + shellColor.value.replace('#', '') }}
                                                        onClick={e => doAction(e, 'shell-color', shellColor.uuid, shellColor.name)}
                                                        className={shellColorUUID == shellColor.uuid ? 'active' : null}
                                                    >
                                                        {/*<h5>{shellColor.name}</h5>*/}
                                                    </button>
                                                    <span>{shellColor.name}</span>
                                                </li>
                                            );
                                        })}
                                    </>
                                ) : null}
                                <div
                                    style={{
                                        borderBottom: '1px solid lightgray',
                                        marginTop: '10px',
                                        marginBottom: '10px',
                                    }}
                                ></div>
                            {/*
                                <li>
                                    <input
                                        type="color"
                                        id="colorPicker"
                                        className={shellColorUUID == 'custom' ? 'active' : null}
                                        onBlur={(e) => setColorMouseUp(e.target.value, activeColorChoose === 'tabs' ? 'tabs-color' : 'shell-color')}

                                        onChange={e => setColor(e.target.value)}
                                        value={color}
                                    />


                                    <span>  <FormattedMessage {...messages.editor_edit_window_color_set_custom_color}></FormattedMessage></span>
                                </li>*/}

                            </ul>
                        </div>
                    </div>
                </ModalWindow>
            </ModalsWrapper>




            <PackshotDetailModal
                language={language}
                lowQualityStatus={lowQualityStatus}
                mediumQualityStatus={mediumQualityStatus}
                highQualityStatus={highQualityStatus}
                loadRenderViews={loadRenderViews}
                loadRendersShow={loadRendersShow}
                loadTransitionRendersShow={loadTransitionRendersShow}
                    renderSceneViewOpenedUUID={renderSceneViewOpenedUUID}
                    showRenderModalTransition={showRenderModalTransition}
                    showRenderModal={showRenderModal}
                    packshotDetailOpened={packshotDetailOpened}
                    packshotDetailName={packshotDetailName}
                    setPackshotDetailOpened={closePackshotOpened}

                versionProductUUID={slug}
                    closeRenderShow={closeRenderShow}
                    packshotsList={packshotsList}
                    setPackshotsList={setPackshotsList}
                    choosePackshotDetail={choosePackshotDetail}
                    packshotDetailThumbnail={packshotDetailThumbnail}
                    packshotDetailDescription={packshotDetailDescription}
                    lowPackshotDate={lowPackshotDate}
                    lowPackshotUrl={lowPackshotUrl}
                    lowQualityRendering={lowQualityRendering}
                    openRenderPackshot={openRenderPackshot}
                    pricingLow={pricingLow}
                    estimatedTimeRenderLow={estimatedTimeRenderLow}
                    estimatedTimeRenderMid={estimatedTimeRenderMid}
                    estimatedTimeRenderHigh={estimatedTimeRenderHigh}

                    mediumPackshotDate={mediumPackshotDate}
                    mediumPackshotUrl={mediumPackshotUrl}
                    mediumQualityRendering={mediumQualityRendering}
                    pricingMedium={pricingMedium}
                    highPackshotDate={highPackshotDate}
                    highPackshotUrl={highPackshotUrl}
                    highQualityRendering={highQualityRendering}
                    pricingHigh={pricingHigh}

                    setLowQualityRendering={setLowQualityRendering}
                    setMediumQualityRendering={setMediumQualityRendering}
                    setHighQualityRendering={setHighQualityRendering}
                    setPackshotDetailThumbnail={setPackshotDetailThumbnail}
                    setLowPackshotUrl={setLowPackshotUrl}
                    setMediumPackshotUrl={setMediumPackshotUrl}
                    setHighPackshotUrl={setHighPackshotUrl}
                    triggerWarning={triggerWarning}
                    triggerAlert={triggerAlert}
                    currentCreditsAlocate={currentCreditsAlocate}
                    //  setCurrentCreditsAlocate={setCurrentCreditsAlocate}
            />




            <DialogConfirmRender
                creditAmount={creditAmount}
                renderTime={renderTime}
                toggleConfirmRender={(toggleConfirmRender: () => void) => {
                    handleCLickConfirmRender = toggleConfirmRender;
                }}
                toggleConfirmRenderClose={(toggleConfirmRenderClose: () => void) => {
                    handleCLickConfirmRenderClose = toggleConfirmRenderClose;
                }}
                renderPackshot={renderPackshot}
                qualityRender={qualityRender}
            />



            <DialogEditor
                downloadSketch={downloadSketch}
                masterProductUUID={masterProductUUID}
                versionProductUUID={versionProductUUID}
                windowEditorType={windowEditorType}
                toggleEditorWindow={(toggleEditor: () => void) => {
                    handleClickEditor = toggleEditor;
                }}
                toggleEditorWindowFinishUpload={(toggleEditorFinishUpload: () => void) => {
                    handleFinishUploadWindow = toggleEditorFinishUpload;
                }}
                templateHeight={templateHeight}
                templateWidth={templateWidth}
                dialogEditorType={dialogEditorType}
                setUploadedTexture={setUploadedTexture}
                setUploadedTextureType={setUploadedTextureType}
            />

            <DialogChooseProductShrink
                masterProductUUID={masterProductUUID}
                versionProductUUID={versionProductUUID}
                windowEditorType={windowEditorType}
                versionUUIDShrinkInside={versionUUIDShrinkInside}
                setVersionUUIDShrinkInside={setVersionUUIDShrinkInside}
                displayCanvasThumbnail={displayCanvasThumbnail}
                toggleEditorWindowInsideShrinkProducts={(toggleEditorInsideShrinkProducts: () => void) => {
                    handleClickInsideShrinkProducts = toggleEditorInsideShrinkProducts;
                }}
                plugin={plugin}
                masterProductShrinkUUID={parentUUIDShrinkInside}
                versionProductShrinkUUID={versionUUIDShrinkInside}
                setDisplayCanvasThumbnail={setDisplayCanvasThumbnail}
                productInsideShrinkProductType={productInsideShrinkProductType}
                productInsideShrinkVolume={productInsideShrinkVolume}
                setProductInsideShrinkAPI={setProductInsideShrinkAPI}
                productsInsideShrinkAvailable={productsInsideShrinkAvailable}
            />

            <DialogAlert
                toggleAlert={(toggleAlert: () => void) => {
                    handleClickEditorMessage = toggleAlert;
                }}
                doRedirect={true}
                alertType={'error'}
                message={wrongEditorMessage}
            />

            <DialogAlert
                toggleAlert={(toggleAlert: () => void) => {
                    handleClickEditorMessage2 = toggleAlert;
                }}
                doRedirect={false}
                alertType={alertTypeEditor}
                message={wrongEditorMessage}
                isMessageReady={true}
            />

            <DialogDeleteComment
                versionUUID={versionProductUUID}
                corectionUUID={correctionDeleteUUID}
                toggleDeleteComment={(toggleDeleteComment: () => void) => {
                    handleClickDeleteComment = toggleDeleteComment;
                }}
                triggerWarning={triggerWarning}

               reloadComments={loadComments}
            />


            <LoaderEditor
                className={`editorLoader ${loadTransitionProductsShow ? 'showTransition' : 'hideTransition'} ${!loadProductsShow ? 'hiddeComplete' : ''} `}
                style={{
                    transition:"all 0.3s ease",
                    width: '100%',
                    height: '100%',
                    top: '0',
                    left: '0',
                    opacity:"0",
                    position: 'fixed',
                    zIndex: "999999999",
                    background: 'white',
                }}
            >

                {typeLoading === 'action' ? <div className={'innerLoading'}>
                    <img style={{ width: '50px' }} src={'/logoAnimate.svg'} />
                </div> : null}
                {typeLoading === 'initMane' ?
                    <div className={'innerLoading'}>
                        <CircularProgressbar value={loadingProgressPercent} text={`${loadingProgressPercent}%`}
                                             strokeWidth={1.5} />

                        {loadingProgressSentence === 'prepairing' ?
                            <p><FormattedMessage {...messages.editor_loading_prepairing}></FormattedMessage></p>
                            : null}
                        {loadingProgressSentence === 'loading' ?
                            <p><FormattedMessage {...messages.editor_loading_loading}></FormattedMessage></p>
                            : null}

                        {loadingProgressSentence === 'mixing' ?
                            <p><FormattedMessage {...messages.editor_loading_mixing}></FormattedMessage></p>
                            : null}

                        {loadingProgressSentence === 'finishing' ?
                            <p><FormattedMessage {...messages.editor_loading_finishing}></FormattedMessage></p>
                            : null}


                    </div>
                    :null
                }

            </LoaderEditor>

            <ReactTooltip />
        </>
    );
}
